import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Typography,
  CircularProgress,
  Card,
  CardContent,
  Grid,
  Box,
  Paper,
  TextField,
  Autocomplete,
  Checkbox,
  Stepper,
  StepLabel,
  Step,
  Chip,
  Tooltip,
  IconButton,
  InputAdornment,
  Pagination,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tab,
  Tabs
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import {
  deleteRequest,
  getRequestWithToken,
  patchRequestWithToken,
  postRequest,
  putRequestWithToken,
} from "../../utils/ApiRequests";
import "./new.scss";
import { blueGrey } from "@mui/material/colors";
import AddIcon from "@mui/icons-material/Add";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { GlobalContext } from "../../components/GlobalStateProvide/GlobalStateProvider";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ModalComponent from "../../components/ModalComponent/ModalComponent";
import { Formik } from "formik";
import {
  CreateJobRolesValidationSchema,
  CreateOccupationValidationSchema,
  CreateOccupationValidationSecondSchema,
  CreateSectorValidationSchema,
  CreateJobRolesValidationSecondSchema,
  CreateJobRolesValidationThirdSchema

} from "../../utils/Validations";
import SureYouWantToDeletModal from "../../components/SureYouWantToDeleteModal/SureYouWantToDeletModal";
import { checkPermission } from "../../utils/userPermissions";
import Unauthorized from "../../components/unauthorized/Unauthorized";
import { useTheme, useMediaQuery } from "@mui/material";
import RichTextEditor from 'react-rte';

import DragAndDropComponent from "../../components/DragAndDropComponent/DragAndDropComponent";
import RichTextEditorWrapper from "../../components/RichTextEditorWrapper/RichTextEditorWrapper";
import "../candidateRoleMappings/candidateRoleMappings.scss";
import HierarchyQuickSearch from "./components/HierarchyQuickSearch";
import HierarchyTreeView from "./components/HierarchyTreeView";
import ObjectIdBadge from "./components/ObjectIdBadge";
import CandidateRoleSelector from "../../components/CandidateRoleSelector/CandidateRoleSelector";
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(blueGrey[50]),
  backgroundColor: "#FFFFFF",
  "&:hover": {
    backgroundColor: blueGrey[50],
  },
}));

const JobSecOccuRole = ({ pageName }) => {
  const navigate = useNavigate();
  const [sector, setSector] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [jobRoles, setJobRoles] = useState([]);
  const [initialStateForJobSector, setInitialStateForJobSector] = useState({
    sectorNameEn: "",
    sectorNameHn: "",
    sectorNameHi: "",
    sectorNameTa: "",
    sectorNameTe: "",
    sectorNameKn: "",
    sectorNameBn: "",
    sectorNameGu: "",
    sectorNameMr: "",
    sectorSeoTitle: "",
    sectorSeoDescription: "",
    sectorPageTitle: "",
    sectorPageContent: "",
    svgImage: "",

  });
  const [initialStateForDepartment, setInitialStateForDepartment] = useState({
    occupationNameEn: "",
    occupationNameHi: "",
    occupationNameHn: "",
    occupationNameTa: "",
    occupationNameTe: "",
    occupationNameKn: "",
    occupationNameBn: "",
    occupationNameGu: "",
    occupationNameMr: "",
    ncoId: "",
    sectorId: "",
    occupationSeoTitle: "",
    occupationSeoDescription: "",
    occupationPageTitle: "",
    occupationPageContent: "",
    svgImage2: "",
  });

  const [initialStateForJobRole, setInitialStateForJobRole] = useState({
    jobRoleNameEn: "",
    jobRoleNameHi: "",
    jobRoleNameHn: "",
    jobRoleNameTa: "",
    jobRoleNameTe: "",
    jobRoleNameKn: "",
    jobRoleNameBn: "",
    jobRoleNameGu: "",
    jobRoleNameMr: "",
    jobRoleImageUrl: "",
    occupationType: "",
    ncoCode: "",
    nsqfLevel: null,
    jobRoleSeoTitle: "",
    jobRoleSeoDescription: "",
    jobRolePageTitle: "",
    jobRolePageContent: "",
    svgImage: "",
    hiringCreditPerVacancy: "",
    mulHiringCreditAfterVacancy: "",
    hiringCreditForContact: "",
    hiringCreditForCVDownload: "",
  });
  const [editJobSectorId, setEditJobSectorId] = useState("");

  const { handleSnackBar } = useContext(GlobalContext);
  const [algoilaProcess, setAlgoliaProsess] = useState(false);
  const [selectedSector, setSelectedSector] = useState("");
  const [selectedSectorId, setSelectedSectorId] = useState("");

  const [selectedOccupation, setSelectedOccupation] = useState("");
  const [selectedOccupationId, setSelectedOccupationId] = useState("");

  const [selectedJobRole, setSelectedJobRole] = useState("");
  const [selectedJobRoleId, setSelectedJobRoleId] = useState("");
  const [hierarchyView, setHierarchyView] = useState(0);
  const isRevealingHierarchy = useRef(false);
  const [hierarchyRevision, setHierarchyRevision] = useState(0);
  const [mappingRevision, setMappingRevision] = useState(0);
  const [highlightedRoleId, setHighlightedRoleId] = useState("");
  const roleCardRefs = useRef({});
  const revealSequence = useRef(0);

  const [mappings, setMappings] = useState([]);
  const [mappingsLoading, setMappingsLoading] = useState(false);
  const [mappingSearch, setMappingSearch] = useState("");
  const searchTimer = useRef(null);
  const [mappingPage, setMappingPage] = useState(1);
  const [mappingTotal, setMappingTotal] = useState(0);
  const [mappingTotalPages, setMappingTotalPages] = useState(0);
  const [candidateRoleSelection, setCandidateRoleSelection] = useState({ family: null, group: null, role: null });
  const [candidateMappingSelection, setCandidateMappingSelection] = useState({ family: null, group: null, role: null });
  const [createFamilyIcon, setCreateFamilyIcon] = useState("");
  const [createLevelId, setCreateLevelId] = useState("L0");
  const [sectorSearch, setSectorSearch] = useState("");
  const [occupationSearch, setOccupationSearch] = useState("");
  const [jobRoleSearch, setJobRoleSearch] = useState("");
  const langCodes = ["hi", "hn", "ta", "te", "kn", "bn", "gu", "mr"];
  const langLabels = { hi: "Hindi", hn: "Haryanvi", ta: "Tamil", te: "Telugu", kn: "Kannada", bn: "Bengali", gu: "Gujarati", mr: "Marathi" };
  const initLangObj = (extraFields) => Object.fromEntries(langCodes.map(c => [c, extraFields?.[c] || ""]));
  const [createLevelLabels, setCreateLevelLabels] = useState(initLangObj());
  const [createAliasesEn, setCreateAliasesEn] = useState("");
  const [createAliasesLang, setCreateAliasesLang] = useState(initLangObj());
  const [deleteMappingModal, setDeleteMappingModal] = useState({ open: false, id: null, name: "" });
  const [mappingDeleteLoading, setMappingDeleteLoading] = useState(false);
  const [editMappingModal, setEditMappingModal] = useState({ open: false, data: null, id: null });
  const [mappingUpdateLoading, setMappingUpdateLoading] = useState(false);

  const [openSectorModal, setOpenSectorModal] = useState(false);
  const [openSectorViewModal, setOpenSectorViewModal] = useState(false);
  const [openDepartmentViewModal, setOpenDepartmentViewModal] = useState(false);
  const [openJobRoleViewModal, setOpenJobRoleViewModal] = useState(false);
  const [jobRoleViewLink, setJobRoleViewLink] = useState({ loading: false, data: null, error: "" });
  const [openDepartmentModal, setOpenDepartmentModal] = useState("");
  const [openJobRoleModal, setOpenJobRoleModal] = useState(false);
  const [ncoPrerequisiteOpen, setNcoPrerequisiteOpen] = useState(false);
  const [openDeleteJobSectorModal, setOpenDeleteJobSectorModal] =
    useState(false);
  const [departmentId, setDepartmentId] = useState("");
  const [jobRoleId, setJobRoleId] = useState("");
  const [openDeleteModalOfDepartment, setOpenDeleteModalOfDepartment] =
    useState(false);
  const [openDeleteModalOfJobRole, setOpenDeleteModalOfJobRole] =
    useState(false);
  const [showLoaderForSector, setShowLoaderForSector] = useState(false);
  const [showLoaderForDepartement, setShowLoaderForDepartement] =
    useState(false);
  const [showLoaderForJobRoles, setShowLoaderForJobRoles] = useState(false);

  // permissions
  const [canCreate, setCanCreate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canRead, setCanRead] = useState(false);

  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(null);
  const [fileData, setFileData] = useState("");



  const getSector = async () => {
    setShowLoaderForSector(true);
    try {
      let data = await getRequestWithToken(
        `admin/sectors?search=`
      );
      if (data.data.status === "Success") {
        setSector([...data.data.data]);
        setShowLoaderForSector(false);
      }
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg || error?.msg, "error");
      setShowLoaderForSector(false);
    }
  };

  const checkPermissionFunc = () => {
    const resourceToUpdate = pageName === "seo" ? "SEO" : "Job Category";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate);
    setCanDelete(permissions.canDelete);
    setCanUpdate(permissions.canUpdate);
    setCanRead(permissions.canRead);
  };

  const againCheckPermissions = () => {
    const checkAccesInArray = localStorage.getItem("resourceNames");
    setisAccess(checkAccesInArray);
    isIncludes();
  };

  useEffect(() => {
    checkPermissionFunc();
    againCheckPermissions();
  }, [isIncludesValue]);

  useEffect(() => {
    getSector();
    loadMappings(1, "");
  }, []);

  useEffect(() => {
    loadMappings(mappingPage, mappingSearch);
  }, [mappingPage]);

  useEffect(() => {
    setMappingPage(1);
    loadMappings(1, mappingSearch);
  }, [mappingSearch]);

  useEffect(() => {
    if (selectedSectorId && !isRevealingHierarchy.current) {
      getDepartment(selectedSectorId);
    }
  }, [selectedSector, selectedSectorId]);

  useEffect(() => {
    if (selectedOccupationId && !isRevealingHierarchy.current) {
      // setSelectedDepartment("");
      getJobRoles(selectedOccupationId);
    }
  }, [selectedOccupation, selectedOccupationId]);

  const getDepartment = async (jobsector, silent = false) => {
    setJobRoles([]);
    setShowLoaderForDepartement(true);
    try {
      let data = await getRequestWithToken(
        `admin/occupations?sectorId=${jobsector}`
      );
      if (data.data.status === "Success") {
        console.log(
          " this is data2...................",
          data.data.data.occupationNameEn
        );
        setOccupations([...data.data.data]);
        console.log("data found", [data.data.data]);
        setShowLoaderForDepartement(false);
        return data.data.data;
      } else {
        console.log("data not found");
        handleSnackBar(true, data.data.status, "error");
      }
    } catch (error) {
      if (!silent) handleSnackBar(true, error?.response?.data?.msg || error?.msg, "error");
      setOccupations([]);
      setJobRoles([]);
      setShowLoaderForDepartement(false);
      return [];
    }
    setShowLoaderForDepartement(false);
    return [];
  };

  const getJobRoles = async (jobOccupation, silent = false) => {
    setShowLoaderForJobRoles(true);
    try {
      let data = await getRequestWithToken(
        `admin/job-roles?occupation=${jobOccupation}`
      );
      if (data.data.status === "Success") {
        // console.log(" this is data2...................", data.data.data);
        setJobRoles([...data.data.data]);
        // console.log("data found", [data.data.data]);
        setShowLoaderForJobRoles(false);
        return data.data.data;
      } else {
        console.log("data not found");
        handleSnackBar(true, data.data.status, "error");
      }
    } catch (error) {
      if (!silent) handleSnackBar(true, error?.response?.data?.msg || error?.msg, "error");
      setJobRoles([]);
      setShowLoaderForJobRoles(false);
      return [];
    }
    setShowLoaderForJobRoles(false);
    return [];
  };

  const handleCopyObjectId = async (objectId) => {
    try {
      await navigator.clipboard.writeText(objectId);
      handleSnackBar(true, "ObjectId copied", "success");
    } catch (error) {
      handleSnackBar(true, "Unable to copy ObjectId", "error");
    }
  };

  const revealHierarchyPath = async (path) => {
    if (!path?.sector?._id || !path?.occupation?._id || !path?.role?._id) return;
    const requestId = revealSequence.current + 1;
    revealSequence.current = requestId;
    isRevealingHierarchy.current = true;
    setHierarchyView(0);
    setSectorSearch("");
    setOccupationSearch("");
    setJobRoleSearch("");
    setSelectedSector(path.sector.name || "");
    setSelectedSectorId(path.sector._id);
    setSelectedOccupation("");
    setSelectedOccupationId("");
    setSelectedJobRole("");
    setSelectedJobRoleId("");
    setOccupations([]);
    setJobRoles([]);

    const loadedOccupations = await getDepartment(path.sector._id, true);
    if (requestId !== revealSequence.current) return;
    const occupation = loadedOccupations.find((item) => item._id === path.occupation._id);
    if (!occupation) {
      isRevealingHierarchy.current = false;
      handleSnackBar(true, "The occupation is no longer available in this sector", "warning");
      return;
    }

    setSelectedOccupation(occupation.occupationNameEn);
    setSelectedOccupationId(occupation._id);
    const loadedRoles = await getJobRoles(occupation._id, true);
    if (requestId !== revealSequence.current) return;
    const role = loadedRoles.find((item) => item._id === path.role._id);
    if (!role) {
      isRevealingHierarchy.current = false;
      handleSnackBar(true, "The role is no longer available in this occupation", "warning");
      return;
    }

    setSelectedJobRole(role.jobRoleNameEn);
    setSelectedJobRoleId(role._id);
    setHighlightedRoleId(role._id);
    isRevealingHierarchy.current = false;
    setTimeout(() => {
      roleCardRefs.current[role._id]?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 100);
    setTimeout(() => setHighlightedRoleId((current) => current === role._id ? "" : current), 2500);
  };
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  const iconOptions = { "🌾": "Agriculture / Farming", "🐄": "Animal / Dairy", "🏗️": "Construction", "🍳": "Cook / Kitchen", "🏨": "Hotel / Hospitality", "💄": "Beauty / Salon", "💇": "Salon / Grooming", "🧹": "Cleaning / Housekeeping", "🚚": "Driver / Transport", "📦": "Delivery / Warehouse", "🔌": "Electronics", "📡": "Telecom", "🔧": "Technician / Repair", "🛠️": "Maintenance", "🔩": "Mechanic", "⚡": "Electrician", "🏥": "Nurse / Healthcare", "🛡️": "Security / Guard", "🛒": "Sales / Retail", "🏪": "Shop / Store", "🌿": "Field / Outdoor", "📋": "Office / Admin", "💻": "IT / Software", "📚": "Teacher / Education", "🍔": "Food / Restaurant", "🤝": "Helper", "👷": "Worker", "👔": "Supervisor / Manager", "⚙️": "Engineer", "🎨": "Painting", "🔥": "Welding", "🪚": "Carpentry", "🧵": "Tailoring", "👕": "Laundry", "🌱": "Gardening", "🖨️": "Printing" };
  const getIconEmoji = (icon) => {
    if (!icon) return "📁";
    return icon;
  };

  // ── Candidate Role Mapping ──
  const loadMappings = async (page = 1, search = "") => {
    setMappingsLoading(true);
    try {
      let url = `../v3/admin/candidate-role-mappings?limit=50&page=${page}&status=active`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      const res = await getRequestWithToken(url);
      if (res.data?.status === "Success") {
        setMappings(res.data?.data?.mappings || []);
        setMappingTotal(res.data?.data?.pagination?.total || 0);
        setMappingTotalPages(res.data?.data?.pagination?.totalPages || 0);
      }
    } catch (err) {
      handleSnackBar(true, err?.response?.data?.msg || "Failed to load mappings", "error");
    }
    setMappingsLoading(false);
  };

  const handleCreateMapping = async () => {
    if (!selectedSectorId || !selectedOccupationId || !selectedJobRoleId) {
      handleSnackBar(true, "Please select sector, occupation, and job role first", "warning");
      return;
    }
    if (!candidateMappingSelection.role?._id) {
      handleSnackBar(true, "Select an existing Candidate Role with an English alias", "warning");
      return;
    }
    try {
      const res = await putRequestWithToken(`../v3/admin/candidate-role-mappings/nco-links/${selectedJobRoleId}`, {
        role_item_id: candidateMappingSelection.role._id,
        source_sector_ref: selectedSectorId,
      });
      if (res.data?.status === "Success") {
        handleSnackBar(true, res.data?.msg || "Mapping created successfully", "success");
        setMappingPage(1);
        setMappingRevision((previous) => previous + 1);
        loadMappings(1);
      } else {
        handleSnackBar(true, res.data?.msg || "Failed to create mapping", "error");
      }
    } catch (err) {
      handleSnackBar(true, err?.response?.data?.msg || err?.msg || "Failed to create mapping", "error");
    }
  };

  const handleDeleteMapping = async () => {
    setMappingDeleteLoading(true);
    try {
      const res = await deleteRequest(`../v3/admin/candidate-role-mappings/${deleteMappingModal.id}`);
      if (res.data?.status === "Success") {
        handleSnackBar(true, res.data?.msg || "Mapping deleted", "success");
        setDeleteMappingModal({ open: false, id: null, name: "" });
        setMappingRevision((previous) => previous + 1);
        loadMappings(mappingPage);
      } else {
        handleSnackBar(true, res.data?.msg || "Delete failed", "error");
      }
    } catch (err) {
      handleSnackBar(true, err?.response?.data?.msg || err?.msg || "Delete failed", "error");
    }
    setMappingDeleteLoading(false);
  };
  const handleUpdateMapping = async (values) => {
    setMappingUpdateLoading(true);
    try {
      const res = await patchRequestWithToken(`../v3/admin/candidate-role-mappings/${editMappingModal.id}`, values);
      if (res.data?.status === "Success") {
        handleSnackBar(true, res.data?.msg || "Mapping updated", "success");
        setEditMappingModal({ open: false, data: null, id: null });
        setMappingRevision((previous) => previous + 1);
        loadMappings(mappingPage);
      } else {
        handleSnackBar(true, res.data?.msg || "Update failed", "error");
      }
    } catch (err) {
      handleSnackBar(true, err?.response?.data?.msg || err?.msg || "Update failed", "error");
    }
    setMappingUpdateLoading(false);
  };
  // ── End Candidate Role Mapping ──

  const handleJobSectorSubmit = async (values) => {
    // setErrors("sectorPageContent", "hello");
    // return;
    let payload = new FormData();
    // payload = {
    //   sectorNameEn: capitalize(values.sectorNameEn),
    //   sectorNameHn: capitalize(values.sectorNameHn),
    //   sectorNameHi: capitalize(values.sectorNameHi),
    //   metaTitle: !values.sectorSeoTitle ? "" : values.sectorSeoTitle,
    //   metaDescription: !values.sectorSeoDescription
    //     ? ""
    //     : values.sectorSeoDescription,
    //   pageContentTitle: !values.sectorPageTitle ? "" : values.sectorPageTitle,
    //   pageContentText: !values.sectorPageContent
    //     ? ""
    //     : values.sectorPageContent,
    //   image: values.svgPngImg
    // };


    payload.append("sectorNameEn", capitalize(values.sectorNameEn));
    payload.append("sectorNameHn", capitalize(values.sectorNameHn));
    payload.append("sectorNameHi", capitalize(values.sectorNameHi));
    payload.append("sectorNameTa", capitalize(values.sectorNameTa));
    payload.append("sectorNameTe", capitalize(values.sectorNameTe));
    payload.append("sectorNameKn", capitalize(values.sectorNameKn));
    payload.append("sectorNameBn", capitalize(values.sectorNameBn));
    payload.append("sectorNameGu", capitalize(values.sectorNameGu));
    payload.append("sectorNameMr", capitalize(values.sectorNameMr));
    payload.append("metaTitle", values.sectorSeoTitle || "");
    payload.append("metaDescription", values.sectorSeoDescription || "");
    payload.append("pageContentTitle", values.sectorPageTitle || "");
    payload.append("pageContentText", values.sectorPageContent || "");

    // Append the image (file) if it exists
    if (values.svgPngImg) {
      payload.append("image", values.svgPngImg[0]);
    }


    // payload.append("sectorNameEn", capitalize(values.sectorNameEn));
    // payload.append("sectorNameHn", capitalize(values.sectorNameHn));
    // payload.append("sectorNameHi", capitalize(values.sectorNameHi));
    // payload.append("metaTitle", values.sectorSeoTitle);
    // payload.append("metaDescription", values.sectorSeoDescription);
    // payload.append("pageContentTitle", values.sectorPageTitle);
    // payload.append("pageContentText", values.sectorPageContent);

    // if(editJobSectorId === ''){
    //   payload.append("image", values.svgPngImg[0]);
    // }
    try {
      const response = editJobSectorId
        ? await patchRequestWithToken(
          `admin/sectors/${editJobSectorId}`,
          payload
        )
        : await postRequest("admin/sectors", payload);
      const { status = "", msg = "" } = response.data;
      if (status === "Success") {
        await getSector();
        setHierarchyRevision((previous) => previous + 1);
        handleSnackBar(true, msg, "success");
        handleCloseJobSectorModal();
      } else handleSnackBar(true, msg, "error");
      setShowLoaderForSector(false);
    } catch (error) {
      setShowLoaderForSector(false);
      handleSnackBar(true, error?.response?.data?.msg || error?.msg, "error");
      setOpenSectorModal(false);
    }
  };

  const handleCloseJobSectorModal = () => {
    setEditJobSectorId("");
    setInitialStateForJobSector({ jobSector: "" });
    setOpenSectorModal(false);
  };
  const handleCloseJobSectorViewModal = () => {
    setEditJobSectorId("");
    setInitialStateForJobSector({ jobSector: "" });
    setOpenSectorViewModal(false);
  };

  const handleDeleteJobSector = async () => {
    try {
      const response = await deleteRequest(`admin/sectors/${editJobSectorId}`);
      const { status, msg } = response.data;
      // console.log(response.data);

      if (status === "Success") {
        await getSector();
        setHierarchyRevision((previous) => previous + 1);
        handleCloseJobSectorModal();
        setOpenDeleteJobSectorModal(false);
        setEditJobSectorId("");
        setSelectedSector("");
        setSelectedOccupationId("");
        handleSnackBar(true, msg, "success");
      } else {
        handleSnackBar(true, msg, "error");
      }
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg, "error");
    }
  };

  const handleDeleteDepartment = async () => {
    try {
      const response = await deleteRequest(`admin/occupations/${departmentId}`);
      const { status = "", msg = "" } = response.data;
      if (status === "Success") {
        await getDepartment(selectedSectorId);
        setHierarchyRevision((previous) => previous + 1);
        handleSnackBar(true, msg, "success");
        setOpenDeleteModalOfDepartment(false);
        setDepartmentId("");
        setSelectedOccupation("");
        setSelectedOccupationId("");
        setJobRoles([]);
        // getJobRoles(selectedOccupationId);
      } else {
        handleSnackBar(true, msg, "error");
        // setShowLoaderForDepartement(false);
      }
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg || error?.msg, "error");
      setShowLoaderForDepartement(false);
    }
  };

  const handleDeleteJobRole = async () => {
    try {
      const response = await deleteRequest(`admin/job-roles/${jobRoleId}`);
      const { status = "", msg = "" } = response.data;
      if (status === "Success") {
        await getJobRoles(selectedOccupationId);
        setHierarchyRevision((previous) => previous + 1);
        handleSnackBar(true, msg, "success");
        setOpenDeleteModalOfJobRole(false);
        setDepartmentId("");
      } else {
        handleSnackBar(true, msg, "error");
        // setShowLoaderForDepartement(false);
      }
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg || error?.msg, "error");
      setShowLoaderForDepartement(false);
    }
  };

  const [selectedSectors, setSelectedSectors] = useState([]);

  const handleAutocompleteChange = (event, value, setFieldValue) => {
    setSelectedSectors(value);
    // console.log(selectedSectors)
    // setInitialStateForDepartment({ ...initialStateForDepartment, sectorId: value });
  };

  const handleDepartmentSubmit = async (values, setErrors) => {

    // console.log("valuesss : ", values);

    if (selectedSectors.length === 0) {
      setErrors({ sectorId: "Please select atleast one sector" });
      setShowLoaderForDepartement(false);
      return;
    }

    const selectedSectorIds = selectedSectors?.map((sector) => sector._id);
    // const payload = {
    //   occupationNameEn: capitalize(values.occupationNameEn),
    //   occupationNameHi: capitalize(values.occupationNameHi),
    //   occupationNameHn: capitalize(values.occupationNameHn),
    //   ncoId: values.ncoId,
    //   sectorId: selectedSectorIds,
    //   metaTitle: values.occupationSeoTitle,
    //   metaDescription: values.occupationSeoDescription,
    //   pageContentTitle: values.occupationPageTitle,
    //   pageContentText: values.occupationPageContent,
    // };
    const payload = new FormData();
    payload.append("occupationNameEn", capitalize(values.occupationNameEn));
    payload.append("occupationNameHi", capitalize(values.occupationNameHi));
    payload.append("occupationNameHn", capitalize(values.occupationNameHn));
    payload.append("occupationNameTa", capitalize(values.occupationNameTa));
    payload.append("occupationNameTe", capitalize(values.occupationNameTe));
    payload.append("occupationNameKn", capitalize(values.occupationNameKn));
    payload.append("occupationNameBn", capitalize(values.occupationNameBn));
    payload.append("occupationNameGu", capitalize(values.occupationNameGu));
    payload.append("occupationNameMr", capitalize(values.occupationNameMr));
    payload.append("ncoId", values.ncoId);
    // payload.append("sectorId", selectedSectorIds);
    payload.append("sectorId", JSON.stringify(selectedSectorIds));

    payload.append("metaTitle", values.occupationSeoTitle || "");
    payload.append("metaDescription", values.occupationSeoDescription || "");
    payload.append("pageContentTitle", values.occupationPageTitle || "");
    payload.append("pageContentText", values.occupationPageContent || "");

    // Append the image (file) if it exists
    if (values.svgPngImg) {
      payload.append("image", values.svgPngImg[0]); // Assuming values.image is the file object (from file input)
    }

    try {
      const response = departmentId
        ? await patchRequestWithToken(
          `admin/occupations/${departmentId}`,
          payload
        )
        : await postRequest("admin/occupations", payload);
      const { status, msg } = response.data;
      if (status === "Success") {
        await getDepartment(selectedSectorId);
        setHierarchyRevision((previous) => previous + 1);
        handleSnackBar(true, msg, "success");
        handleCloseDepartmentModal();
      } else {
        handleSnackBar(true, msg, "error");
        setShowLoaderForDepartement(false);
        setOpenDepartmentModal(false);
      }
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg, "error");
      setShowLoaderForDepartement(false);
      setOpenDepartmentModal(false);
    }
  };

  const handleJobRoleSubmit = async (values) => {
    // const payload = {
    //   jobRoleNameEn: capitalize(values.jobRoleNameEn),
    //   jobRoleNameHi: capitalize(values.jobRoleNameHi),
    //   jobRoleNameHn: capitalize(values.jobRoleNameHn),
    //   occupationType: selectedOccupationId,
    //   ncoCode: values.ncoCode,
    //   nsqfLevel: values.nsqfLevel ? values.nsqfLevel : 0,
    //   hiringCredit: values.hiringCreditPerVacancy
    //     ? parseInt(values.hiringCreditPerVacancy)
    //     : 0,
    //   metaTitle: values.jobRoleSeoTitle,
    //   metaDescription: values.jobRoleSeoDescription,
    //   pageContentTitle: values.jobRolePageTitle,
    //   pageContentText: values.jobRolePageContent,
    // };

    const payload = new FormData();

    // Append text fields to FormData
    payload.append("jobRoleNameEn", capitalize(values.jobRoleNameEn));
    payload.append("jobRoleNameHi", capitalize(values.jobRoleNameHi));
    payload.append("jobRoleNameHn", capitalize(values.jobRoleNameHn));
    payload.append("jobRoleNameTa", capitalize(values.jobRoleNameTa));
    payload.append("jobRoleNameTe", capitalize(values.jobRoleNameTe));
    payload.append("jobRoleNameKn", capitalize(values.jobRoleNameKn));
    payload.append("jobRoleNameBn", capitalize(values.jobRoleNameBn));
    payload.append("jobRoleNameGu", capitalize(values.jobRoleNameGu));
    payload.append("jobRoleNameMr", capitalize(values.jobRoleNameMr));
    payload.append("occupationType", selectedOccupationId);
    if (candidateRoleSelection.role?._id) payload.append("candidate_role_id", candidateRoleSelection.role._id);
    if (selectedSectorId) payload.append("source_sector_ref", selectedSectorId);
    payload.append("ncoCode", values.ncoCode);
    payload.append("nsqfLevel", values.nsqfLevel ? values.nsqfLevel : 0);
    payload.append("hiringCredit", values.hiringCreditPerVacancy ? parseInt(values.hiringCreditPerVacancy) : 0);
    payload.append("metaTitle", values.jobRoleSeoTitle || "");
    payload.append("metaDescription", values.jobRoleSeoDescription || "");
    payload.append("pageContentTitle", values.jobRolePageTitle || "");
    payload.append("pageContentText", values.jobRolePageContent || "");

    payload.append("hiringCreditAfterOneVacancy", values.mulHiringCreditAfterVacancy ? parseInt(values.mulHiringCreditAfterVacancy) : 0);
    payload.append("hiringCreditForContact", values.hiringCreditForContact ? parseInt(values.hiringCreditForContact) : 0);
    payload.append("hiringCreditForCvDownload", values.hiringCreditForCVDownload ? parseInt(values.hiringCreditForCVDownload) : 0);


    // Append the image (file) if it exists
    if (values.svgPngImg) {
      payload.append("image", values.svgPngImg[0]);
    }
    try {
      const response = jobRoleId
        ? await patchRequestWithToken(`admin/job-roles/${jobRoleId}`, payload)
        : await postRequest("admin/job-roles", payload);
      const { status, msg } = response.data;
      if (status === "Success") {
        await getJobRoles(selectedOccupationId);
        setHierarchyRevision((previous) => previous + 1);
        handleSnackBar(true, msg, "success");
        handleCloseJobRoleModal();
      } else {
        handleSnackBar(true, msg, "error");
        setShowLoaderForJobRoles(false);
        setOpenJobRoleModal(false);
      }
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg, "error");
      setShowLoaderForJobRoles(false);
    }
  };

  const handleCloseDepartmentModal = () => {
    setInitialStateForDepartment({ department: "" });
    setDepartmentId("");
    setOpenDepartmentModal(false);
  };

  const handleCloseJobOccupationViewModal = () => {
    setInitialStateForDepartment({ department: "" });
    setDepartmentId("");
    setOpenDepartmentViewModal(false);
  };

  const handleCloseJobRoleModal = () => {
    setInitialStateForJobRole({ department: "" });
    setJobRoleId("");
    setCandidateRoleSelection({ family: null, group: null, role: null });
    setOpenJobRoleModal(false);
  };
  const handleCloseJobRoleViewModal = () => {
    // setInitialStateForJobRole({ department: "" });
    setJobRoleId("");
    setJobRoleViewLink({ loading: false, data: null, error: "" });
    setOpenJobRoleViewModal(false);
  };

  const isIncludes = () => {
    setisIncludesValue(
      isAccess.includes(pageName === "seo" ? "SEO" : "Job Category")
    );
  };

  const syncAlgolia = () => {
    const syncData = async () => {
      try {
        setAlgoliaProsess(true);
        const response = await postRequest(
          `${import.meta.env.VITE_API_BASE_URL}algolia/sync-data`
        );
        if (response.data.status === "Success") {
          setAlgoliaProsess(false);
        }
      } catch (error) {
        setAlgoliaProsess(false);
      }
    };

    syncData();
  };

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));

  const modalWidth = isXs ? "50%" : isMd ? "70%" : "35%";

  //Rich text Area content

  const [activeStep, setActiveStep] = useState(0);

  const JobSectorStepper = pageName === "seo" ? ["Add Job Sector", "Upload Image", "SEO"] : ["Add Job Sector", "Upload Image"]
  const JobOccupationStepper = pageName === "seo" ? ["Add Job Occupation", "Other Informations", "SEO"] : ["Add Job Occupation", "Other Informations"]
  const JobRoleStepper = pageName === "seo" ? ["Add Job Role", "Other Informations", "Hiring Credits Details", "SEO"] : ["Add Job Role", "Other Informations", "Hiring Credits Details", "Candidate Mapping"]

  const openJobSectorsModal = () => {
    setEditJobSectorId("");
    setInitialStateForJobSector({
      sectorNameEn: "",
      sectorNameHn: "",
      sectorNameHi: "",
      sectorNameTa: "",
      sectorNameTe: "",
      sectorNameKn: "",
      sectorNameBn: "",
      sectorNameGu: "",
      sectorNameMr: "",
      sectorSeoTitle: "",
      sectorSeoDescription: "",
      sectorPageTitle: "",
      sectorPageContent: "",
      svgImage: "",
    });
    setOpenSectorModal(true);
    setActiveStep(0)
  }
  const handleAddOccupationModal = () => {
    setDepartmentId("");
    setInitialStateForDepartment({
      occupationNameEn: "",
      occupationNameHi: "",
      occupationNameHn: "",
      occupationNameTa: "",
      occupationNameTe: "",
      occupationNameKn: "",
      occupationNameBn: "",
      occupationNameGu: "",
      occupationNameMr: "",
      ncoId: "",
      sectorId: "",
      occupationSeoTitle: "",
      occupationSeoDescription: "",
      occupationPageTitle: "",
      occupationPageContent: "",
      svgImage2: ""
    });
    setOpenDepartmentModal(true);
    setActiveStep(0)
    setSelectedSectors([]);
  }

  const openJobRoleForm = () => {
    setCandidateRoleSelection({ family: null, group: null, role: null });
    setDepartmentId("");
    setInitialStateForJobRole({
      jobRoleNameEn: "",
      jobRoleNameHi: "",
      jobRoleNameHn: "",
      jobRoleNameTa: "",
      jobRoleNameTe: "",
      jobRoleNameKn: "",
      jobRoleNameBn: "",
      jobRoleNameGu: "",
      jobRoleNameMr: "",
      jobRoleImageUrl: "",
      occupationType: "",
      ncoCode: "",
      nsqfLevel: null,
      jobRoleSeoTitle: "",
      jobRoleSeoDescription: "",
      jobRolePageTitle: "",
      jobRolePageContent: "",
      svgImage: "",
      hiringCreditPerVacancy: "",
      mulHiringCreditAfterVacancy: "",
      hiringCreditForContact: "",
      hiringCreditForCVDownload: ""
    });
    setOpenJobRoleModal(true);
    setActiveStep(0)
  }

  const handleAddJobRoleModal = () => setNcoPrerequisiteOpen(true);

  const UpdateJobSectorValues = (item) => {
    setInitialStateForJobSector({
      ...initialStateForJobSector,
      sectorNameEn: item.sectorNameEn,
      sectorNameHn: item.sectorNameHn,
      sectorNameHi: item.sectorNameHi,
      sectorNameTa: item.sectorNameTa,
      sectorNameTe: item.sectorNameTe,
      sectorNameKn: item.sectorNameKn,
      sectorNameBn: item.sectorNameBn,
      sectorNameGu: item.sectorNameGu,
      sectorNameMr: item.sectorNameMr,
      sectorSeoTitle: item.metaTitle
        ? item.metaTitle
        : "",
      sectorSeoDescription: item.metaDescription
        ? item.metaDescription
        : "",
      sectorPageContent: item.pageContentText
        ? item.pageContentText
        : "",
      sectorPageTitle: item.pageContentTitle
        ? item.pageContentTitle
        : "",
    });

  }

  const UpdateJobOccupationValues = (item) => {
    setInitialStateForDepartment({
      ...initialStateForDepartment,
      occupationNameEn: item.occupationNameEn,
      occupationNameHi: item.occupationNameHi,
      occupationNameHn: item.occupationNameHn,
      occupationNameTa: item.occupationNameTa,
      occupationNameTe: item.occupationNameTe,
      occupationNameKn: item.occupationNameKn,
      occupationNameBn: item.occupationNameBn,
      occupationNameGu: item.occupationNameGu,
      occupationNameMr: item.occupationNameMr,
      ncoId: item.ncoId,
      // sectorId: sector?.filter(Item => item.sectorId.includes(Item._id)),
      occupationSeoTitle: item.metaTitle
        ? item.metaTitle
        : "",
      occupationSeoDescription:
        item.metaDescription
          ? item.metaDescription
          : "",
      occupationPageContent:
        item.pageContentText
          ? item.pageContentText
          : "",
      occupationPageTitle: item.pageContentTitle
        ? item.pageContentTitle
        : "",
    });
  }

  const UpdateJobRoleValues = (item) => {
    setCandidateRoleSelection({ family: null, group: null, role: null });
    setJobRoleViewLink({ loading: Boolean(item?._id), data: null, error: "" });
    if (item?._id) {
      getRequestWithToken(`../v3/admin/candidate-role-mappings/nco-links?mapped=true&nco_job_role_id=${item._id}&limit=1`)
        .then((response) => {
          const link = response.data?.data?.links?.[0] || null;
          const candidate = link?.candidateRole;
          setJobRoleViewLink({ loading: false, data: link, error: "" });
          if (!candidate) return;
          setCandidateRoleSelection({
            family: candidate.family ? { _id: candidate.family._id, family_id: candidate.family.familyId, family_name: candidate.family.name, family_ui_label: candidate.family.name } : null,
            group: candidate.group ? { _id: candidate.group._id, group_id: candidate.group.groupId, group_name: candidate.group.name, group_ui_label: candidate.group.name } : null,
            role: { _id: candidate._id, role_id: candidate.roleId, role_name: candidate.name, role_ui_label: candidate.name, aliases: { en: candidate.aliases || [] }, allowed_level_ids: candidate.allowedLevelIds || [] },
          });
        })
        .catch((error) => setJobRoleViewLink({ loading: false, data: null, error: error?.response?.data?.msg || "Could not load Candidate Role mapping" }));
    }
    setInitialStateForJobRole({
      ...initialStateForJobRole,
      // department: department?.key,
      jobRoleNameEn: item.jobRoleNameEn,
      jobRoleNameHi: item.jobRoleNameHi,
      jobRoleNameHn: item.jobRoleNameHn,
      jobRoleNameTa: item.jobRoleNameTa,
      jobRoleNameTe: item.jobRoleNameTe,
      jobRoleNameKn: item.jobRoleNameKn,
      jobRoleNameBn: item.jobRoleNameBn,
      jobRoleNameGu: item.jobRoleNameGu,
      jobRoleNameMr: item.jobRoleNameMr,
      jobRoleImageUrl: item.jobRoleImageUrl,
      occupationType: item.occupationType,
      ncoCode: item.ncoCode,
      hiringCreditPerVacancy: item.hiringCredit,
      nsqfLevel: item.nsqfLevel,
      jobRoleSeoTitle: item.metaTitle
        ? item.metaTitle
        : "",
      jobRoleSeoDescription:
        item.metaDescription
          ? item.metaDescription
          : "",
      jobRolePageTitle: item.pageContentTitle
        ? item.pageContentTitle
        : "",
      jobRolePageContent: item.pageContentText
        ? item.pageContentText
        : "",

      mulHiringCreditAfterVacancy: item?.hiringCreditAfterOneVacancy,
      hiringCreditForContact: item?.hiringCreditForContact,
      hiringCreditForCVDownload: item?.hiringCreditForCvDownload,

    });
  }
  return isIncludesValue ? (
    <Box marginX={2} marginY={2} className="job_sector">
      <Box
        style={{ display: pageName === "seo" ? "none" : "flex" }}
        justifyContent="flex-end"
      >
        <Button
          variant="contained"
          style={{ backgroundColor: "#ff671f", margin: "5px" }}
          onClick={() => {
            syncAlgolia();
          }}
          disabled={algoilaProcess}
        >
          {algoilaProcess ? "Syncing" : "Sync"}
        </Button>
      </Box>
      <Box
        sx={{
          p: { xs: 1.25, md: 2 },
          borderRadius: 3,
          bgcolor: (theme) => theme.palette.mode === "dark" ? "#151515" : "#e8e3dc",
          border: "1px solid",
          borderColor: (theme) => theme.palette.mode === "dark" ? "#282828" : "#d3cbc1",
          boxShadow: (theme) => theme.palette.mode === "dark"
            ? "0 12px 30px rgba(0,0,0,0.28)"
            : "0 12px 30px rgba(62,45,28,0.08)",
        }}
      >
        <HierarchyQuickSearch onSelect={revealHierarchyPath} onCopy={handleCopyObjectId} />
        <Tabs
          value={hierarchyView}
          onChange={(_, value) => setHierarchyView(value)}
          aria-label="NCO hierarchy views"
          sx={{
            mb: 1.5,
            minHeight: 42,
            borderBottom: "1px solid",
            borderColor: (theme) => theme.palette.mode === "dark" ? "#333" : "#d2c9be",
            "& .MuiTabs-indicator": { height: 3, borderRadius: "3px 3px 0 0", bgcolor: "#FF8C00" },
            "& .MuiTab-root": {
              minHeight: 42,
              px: 2.5,
              color: "text.secondary",
              fontSize: 13,
              fontWeight: 550,
              "&.Mui-selected": { color: "#E87500", fontWeight: 750 },
            },
          }}
        >
          <Tab label="Card View" />
          <Tab label="Tree View" />
        </Tabs>
        {hierarchyView === 0 ? (
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <Card variant="outlined" sx={{ borderRadius: 2, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                <Box sx={{ px: 2, pt: 1.5, pb: 1, borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="subtitle1" fontWeight={700} fontSize={15}>Job Sectors</Typography>
                    <Chip label={sector.length} size="small" sx={{ height: 20, fontSize: 11, bgcolor: "#eef2ff", color: "#4f46e5", fontWeight: 600 }} />
                  </Box>
                  {canCreate && pageName !== "seo" && (
                    <IconButton size="small" color="primary" onClick={openJobSectorsModal} sx={{ bgcolor: "#f0f7ff", "&:hover": { bgcolor: "#e0efff" } }}>
                      <AddIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>
                <Box sx={{ px: 2, py: 1 }}>
                  <TextField
                    size="small"
                    placeholder="Search sectors..."
                    value={sectorSearch}
                    onChange={(e) => setSectorSearch(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#f8fafc", fontSize: 13 } }}
                  />
                </Box>
                <CardContent sx={{ height: "60vh", overflow: "auto", px: 1, pt: 0, pb: 1, "&::-webkit-scrollbar": { width: 4 }, "&::-webkit-scrollbar-thumb": { bgcolor: "#ddd", borderRadius: 4 } }}>
                  {showLoaderForSector ? (
                    <Box display="flex" sx={{ width: "100%", height: "100%" }} justifyContent="center" alignItems="center">
                      <CircularProgress size={28} />
                    </Box>
                  ) : (
                    sector.filter(s => !sectorSearch || s.sectorNameEn?.toLowerCase().includes(sectorSearch.toLowerCase())).map((item, index) => (
                      <Paper
                        key={item._id || index}
                        onClick={() => {
                          setSelectedSector(item.sectorNameEn);
                          setSelectedSectorId(item._id);
                          setSelectedOccupation("");
                          setSelectedOccupationId("");
                          setSelectedJobRole("");
                          setSelectedJobRoleId("");
                        }}
                        elevation={0}
                        sx={{
                          my: 0.5,
                          cursor: "pointer",
                          borderLeft: selectedSectorId === item._id ? "3px solid #4f46e5" : "3px solid transparent",
                          bgcolor: selectedSectorId === item._id ? "#f8f7ff" : "transparent",
                          borderRadius: 1,
                          transition: "all 0.15s",
                          "&:hover": { bgcolor: "#f5f5f5" }
                        }}
                      >
                        <Box display="flex" alignItems="center" justifyContent="space-between" px={1.5} py={1}>
                          <Box display="flex" alignItems="center" gap={1.5} minWidth={0} flex={1}>
                            <img
                              src={item.imageURL || "https://jobyahanp.s3.ap-south-1.amazonaws.com/images/category-icons/field-sales-officer.png"}
                              width={28} height={28} alt=""
                              style={{ objectFit: "contain", borderRadius: 4 }}
                            />
                            <Box minWidth={0}>
                              <Typography sx={{ textTransform: "capitalize", fontSize: 13, fontWeight: selectedSectorId === item._id ? 600 : 400 }}>
                                {item.sectorNameEn}
                              </Typography>
                              <ObjectIdBadge objectId={item._id} onCopy={handleCopyObjectId} compact />
                            </Box>
                          </Box>
                          <Box display="flex" alignItems="center" gap={0.5}>
                            {canRead && (
                              <IconButton size="small" onClick={(e) => { e.stopPropagation(); UpdateJobSectorValues(item); setActiveStep(0); setOpenSectorViewModal(true); setEditJobSectorId(item._id); }} sx={{ opacity: 0.5, "&:hover": { opacity: 1 } }}>
                                <RemoveRedEyeIcon fontSize="small" sx={{ fontSize: 16 }} />
                              </IconButton>
                            )}
                            {canUpdate && (
                              <IconButton size="small" onClick={(e) => { e.stopPropagation(); UpdateJobSectorValues(item); setActiveStep(0); setOpenSectorModal(true); setEditJobSectorId(item._id); }} sx={{ opacity: 0.5, "&:hover": { opacity: 1 } }}>
                                <EditIcon fontSize="small" sx={{ fontSize: 16 }} />
                              </IconButton>
                            )}
                            {canDelete && pageName !== "seo" && (
                              <IconButton size="small" onClick={(e) => { e.stopPropagation(); setInitialStateForJobSector({ ...initialStateForJobSector, sectorNameEn: item.sectorNameEn }); setEditJobSectorId(item._id); setOpenDeleteJobSectorModal(true); }} sx={{ opacity: 0.5, "&:hover": { opacity: 1, color: "error.main" } }}>
                                <DeleteIcon fontSize="small" sx={{ fontSize: 16 }} />
                              </IconButton>
                            )}
                          </Box>
                        </Box>
                      </Paper>
                    ))
                  )}
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={4}>
              <Card variant="outlined" sx={{ borderRadius: 2, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                <Box sx={{ px: 2, pt: 1.5, pb: 1, borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="subtitle1" fontWeight={700} fontSize={15}>Job Occupations</Typography>
                    <Chip label={occupations.length} size="small" sx={{ height: 20, fontSize: 11, bgcolor: "#f0fdf4", color: "#16a34a", fontWeight: 600 }} />
                  </Box>
                  {selectedSector && pageName !== "seo" && canCreate && (
                    <IconButton size="small" color="success" onClick={handleAddOccupationModal} sx={{ bgcolor: "#f0fdf4", "&:hover": { bgcolor: "#dcfce7" } }}>
                      <AddIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>
                {selectedSector ? (
                  <>
                    <Box sx={{ px: 2, py: 1 }}>
                      <TextField
                        size="small"
                        placeholder="Search occupations..."
                        value={occupationSearch}
                        onChange={(e) => setOccupationSearch(e.target.value)}
                        fullWidth
                        variant="outlined"
                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#f8fafc", fontSize: 13 } }}
                      />
                    </Box>
                    <CardContent sx={{ height: "60vh", overflow: "auto", px: 1, pt: 0, pb: 1, "&::-webkit-scrollbar": { width: 4 }, "&::-webkit-scrollbar-thumb": { bgcolor: "#ddd", borderRadius: 4 } }}>
                      {showLoaderForDepartement ? (
                        <Box display="flex" sx={{ width: "100%", height: "100%" }} justifyContent="center" alignItems="center">
                          <CircularProgress size={28} />
                        </Box>
                      ) : (
                        occupations.filter(o => !occupationSearch || o.occupationNameEn?.toLowerCase().includes(occupationSearch.toLowerCase())).map((item, index) => (
                          <Paper
                            key={item?._id || item?.id || index}
                            onClick={() => {
                              setSelectedOccupation(item.occupationNameEn);
                              setSelectedOccupationId(item._id);
                              setSelectedJobRole("");
                              setSelectedJobRoleId("");
                            }}
                            elevation={0}
                            sx={{
                              my: 0.5,
                              cursor: "pointer",
                              borderLeft: selectedOccupationId === item._id ? "3px solid #16a34a" : "3px solid transparent",
                              bgcolor: selectedOccupationId === item._id ? "#f0fdf4" : "transparent",
                              borderRadius: 1,
                              transition: "all 0.15s",
                              "&:hover": { bgcolor: "#f5f5f5" }
                            }}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" px={1.5} py={1}>
                              <Box display="flex" alignItems="center" gap={1.5} minWidth={0} flex={1}>
                                <img
                                  src={item.imageURL || "https://jobyahanp.s3.ap-south-1.amazonaws.com/images/category-icons/field-sales-officer.png"}
                                  width={28} height={28} alt=""
                                  style={{ objectFit: "contain", borderRadius: 4 }}
                                />
                                <Box minWidth={0}>
                                  <Typography sx={{ textTransform: "capitalize", fontSize: 13, fontWeight: selectedOccupationId === item._id ? 600 : 400 }}>
                                    {item?.occupationNameEn}
                                  </Typography>
                                  <ObjectIdBadge objectId={item._id} onCopy={handleCopyObjectId} compact />
                                </Box>
                              </Box>
                              <Box display="flex" alignItems="center" gap={0.5}>
                                {canRead && (
                                  <IconButton size="small" onClick={(e) => { e.stopPropagation(); UpdateJobOccupationValues(item); setOpenDepartmentViewModal(true); setDepartmentId(item?._id); }} sx={{ opacity: 0.5, "&:hover": { opacity: 1 } }}>
                                    <RemoveRedEyeIcon fontSize="small" sx={{ fontSize: 16 }} />
                                  </IconButton>
                                )}
                                {canUpdate && (
                                  <IconButton size="small" onClick={(e) => { e.stopPropagation(); UpdateJobOccupationValues(item); setActiveStep(0); setOpenDepartmentModal(true); setDepartmentId(item?._id); let sectorId = sector?.filter((Item) => item.sectorId.includes(Item._id)); setSelectedSectors(sectorId); }} sx={{ opacity: 0.5, "&:hover": { opacity: 1 } }}>
                                    <EditIcon fontSize="small" sx={{ fontSize: 16 }} />
                                  </IconButton>
                                )}
                                {canDelete && pageName !== "seo" && (
                                  <IconButton size="small" onClick={(e) => { e.stopPropagation(); setInitialStateForDepartment({ ...initialStateForDepartment, occupationNameEn: item?.occupationNameEn }); setDepartmentId(item?._id); setOpenDeleteModalOfDepartment(true); }} sx={{ opacity: 0.5, "&:hover": { opacity: 1, color: "error.main" } }}>
                                    <DeleteIcon fontSize="small" sx={{ fontSize: 16 }} />
                                  </IconButton>
                                )}
                              </Box>
                            </Box>
                          </Paper>
                        ))
                      )}
                    </CardContent>
                  </>
                ) : (
                  <Box display="flex" alignItems="center" justifyContent="center" sx={{ height: "60vh", color: "#999", flexDirection: "column", gap: 1 }}>
                    <Typography variant="body2" color="text.secondary">Select a sector first</Typography>
                  </Box>
                )}
              </Card>
            </Grid>

            <Grid item xs={4}>
              <Card variant="outlined" sx={{ borderRadius: 2, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                <Box sx={{ px: 2, pt: 1.5, pb: 1, borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="subtitle1" fontWeight={700} fontSize={15}>Job Roles</Typography>
                    <Chip label={jobRoles.length} size="small" sx={{ height: 20, fontSize: 11, bgcolor: "#fff7ed", color: "#ea580c", fontWeight: 600 }} />
                  </Box>
                  {selectedOccupation && pageName !== "seo" && canCreate && (
                    <IconButton size="small" color="warning" onClick={handleAddJobRoleModal} sx={{ bgcolor: "#fff7ed", "&:hover": { bgcolor: "#ffedd5" } }}>
                      <AddIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>
                {selectedOccupation ? (
                  <>
                    <Box sx={{ px: 2, py: 1 }}>
                      <TextField
                        size="small"
                        placeholder="Search job roles..."
                        value={jobRoleSearch}
                        onChange={(e) => setJobRoleSearch(e.target.value)}
                        fullWidth
                        variant="outlined"
                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#f8fafc", fontSize: 13 } }}
                      />
                    </Box>
                    <CardContent sx={{ height: "60vh", overflow: "auto", px: 1, pt: 0, pb: 1, "&::-webkit-scrollbar": { width: 4 }, "&::-webkit-scrollbar-thumb": { bgcolor: "#ddd", borderRadius: 4 } }}>
                      {showLoaderForJobRoles ? (
                        <Box display="flex" sx={{ width: "100%", height: "100%" }} justifyContent="center" alignItems="center">
                          <CircularProgress size={28} />
                        </Box>
                      ) : (
                        jobRoles.filter(r => !jobRoleSearch || r.jobRoleNameEn?.toLowerCase().includes(jobRoleSearch.toLowerCase())).map((item, index) => (
                          <Paper
                            key={item?._id || item?.id || index}
                            ref={(node) => { roleCardRefs.current[item._id] = node; }}
                            onClick={() => {
                              setSelectedJobRole(item?.jobRoleNameEn);
                              setSelectedJobRoleId(item._id);
                            }}
                            elevation={0}
                            sx={{
                              my: 0.5,
                              cursor: "pointer",
                              borderLeft: selectedJobRoleId === item._id ? "3px solid #ea580c" : "3px solid transparent",
                              bgcolor: highlightedRoleId === item._id ? "#fff1cc" : selectedJobRoleId === item._id ? "#fff7ed" : "transparent",
                              boxShadow: highlightedRoleId === item._id ? "0 0 0 2px rgba(234, 88, 12, 0.35)" : "none",
                              borderRadius: 1,
                              transition: "all 0.15s",
                              "&:hover": { bgcolor: "#f5f5f5" }
                            }}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" px={1.5} py={1}>
                              <Box display="flex" alignItems="center" gap={1.5} minWidth={0} flex={1}>
                                <img
                                  src={item.imageURL || "https://jobyahanp.s3.ap-south-1.amazonaws.com/images/category-icons/field-sales-officer.png"}
                                  width={28} height={28} alt=""
                                  style={{ objectFit: "contain", borderRadius: 4 }}
                                />
                                <Box minWidth={0}>
                                  <Typography sx={{ textTransform: "capitalize", fontSize: 13, fontWeight: selectedJobRoleId === item._id ? 600 : 400 }}>
                                    {item?.jobRoleNameEn}
                                  </Typography>
                                  <ObjectIdBadge objectId={item._id} onCopy={handleCopyObjectId} compact />
                                </Box>
                              </Box>
                              <Box display="flex" alignItems="center" gap={0.5}>
                                {canRead && (
                                  <IconButton size="small" onClick={(e) => { e.stopPropagation(); UpdateJobRoleValues(item); setOpenJobRoleViewModal(true); setJobRoleId(item._id); }} sx={{ opacity: 0.5, "&:hover": { opacity: 1 } }}>
                                    <RemoveRedEyeIcon fontSize="small" sx={{ fontSize: 16 }} />
                                  </IconButton>
                                )}
                                {canUpdate && (
                                  <IconButton size="small" onClick={(e) => { e.stopPropagation(); UpdateJobRoleValues(item); setActiveStep(0); setOpenJobRoleModal(true); setJobRoleId(item?._id); }} sx={{ opacity: 0.5, "&:hover": { opacity: 1 } }}>
                                    <EditIcon fontSize="small" sx={{ fontSize: 16 }} />
                                  </IconButton>
                                )}
                                {canDelete && pageName !== "seo" && (
                                  <IconButton size="small" onClick={(e) => { e.stopPropagation(); setInitialStateForJobRole({ ...initialStateForJobRole, jobRoleNameEn: item?.jobRoleNameEn }); setJobRoleId(item?._id); setOpenDeleteModalOfJobRole(true); }} sx={{ opacity: 0.5, "&:hover": { opacity: 1, color: "error.main" } }}>
                                    <DeleteIcon fontSize="small" sx={{ fontSize: 16 }} />
                                  </IconButton>
                                )}
                              </Box>
                            </Box>
                          </Paper>
                        ))
                      )}
                    </CardContent>
                  </>
                ) : (
                  <Box display="flex" alignItems="center" justifyContent="center" sx={{ height: "60vh", color: "#999", flexDirection: "column", gap: 1 }}>
                    <Typography variant="body2" color="text.secondary">Select an occupation first</Typography>
                  </Box>
                )}
              </Card>
            </Grid>
          </Grid>
        ) : (
          <HierarchyTreeView
            sectors={sector}
            revision={hierarchyRevision}
            mappingRevision={mappingRevision}
            selectedSectorId={selectedSectorId}
            selectedOccupationId={selectedOccupationId}
            selectedJobRoleId={selectedJobRoleId}
            onReveal={revealHierarchyPath}
            onCopy={handleCopyObjectId}
          />
        )}
      </Box>

      {/* ── Candidate Role Mapping Section ── */}
      {/* <Box mt={4} className="candidate-role-mappings">
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h5" fontWeight="bold">Candidate Role Mappings</Typography>
          <Chip label={`${mappings.length} mappings`} size="small" color="primary" variant="outlined" />
        </Box>

        <Card variant="outlined" sx={{ p: 2.5, mb: 3, bgcolor: "#FAFBFF" }}>
          <Typography variant="subtitle1" fontWeight={600} mb={2} display="flex" alignItems="center" gap={1}>
            <span style={{ fontSize: 20 }}>&#x1F4CB;</span> Assign Canonical Candidate Role to Current NCO Selection
          </Typography>

          <Grid container spacing={2} alignItems="stretch">
            <Grid item xs={12} md={3}>
              <Paper variant="outlined" sx={{ p: 1.5, height: "100%", bgcolor: "#fff", borderLeft: "3px solid #1976d2" }}>
                <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">NCO Sector</Typography>
                <Typography fontWeight={600} fontSize={14}>{selectedSector || <span style={{ color: "#999", fontStyle: "italic" }}>Not selected</span>}</Typography>
                <Chip label="→ Family" size="small" variant="outlined" color="primary" sx={{ mt: 0.5, height: 20, fontSize: 11 }} />
                <TextField select size="small" label="Family Icon" value={createFamilyIcon} onChange={(e) => setCreateFamilyIcon(e.target.value)} sx={{ mt: 1 }} fullWidth>
                  <MenuItem value="">None</MenuItem>
                  {Object.entries(iconOptions).map(([val, label]) => (
                    <MenuItem key={val} value={val}>{getIconEmoji(val)} {label}</MenuItem>
                  ))}
                </TextField>
              </Paper>
            </Grid>
            <Grid item xs={12} md={3}>
              <Paper variant="outlined" sx={{ p: 1.5, height: "100%", bgcolor: "#fff", borderLeft: "3px solid #388e3c" }}>
                <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">NCO Occupation</Typography>
                <Typography fontWeight={600} fontSize={14}>{selectedOccupation || <span style={{ color: "#999", fontStyle: "italic" }}>Not selected</span>}</Typography>
                <Chip label="→ Group" size="small" variant="outlined" color="success" sx={{ mt: 0.5, height: 20, fontSize: 11 }} />
              </Paper>
            </Grid>
            <Grid item xs={12} md={3}>
              <Paper variant="outlined" sx={{ p: 1.5, height: "100%", bgcolor: "#fff", borderLeft: "3px solid #ed6c02" }}>
                <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">NCO Job Role</Typography>
                <Typography fontWeight={600} fontSize={14}>{selectedJobRole || <span style={{ color: "#999", fontStyle: "italic" }}>Not selected</span>}</Typography>
                <Chip label="→ Role" size="small" variant="outlined" color="warning" sx={{ mt: 0.5, height: 20, fontSize: 11 }} />
              </Paper>
            </Grid>
            <Grid item xs={12} md={3} display="flex" flexDirection="column" justifyContent="center">
              <Box bgcolor={selectedSector && selectedOccupation && selectedJobRole ? "#e8f5e9" : "#f5f5f5"} borderRadius={1} p={1.5} textAlign="center">
                <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">Candidate Category</Typography>
                <Typography fontWeight={700} fontSize={14} color={selectedSector && selectedOccupation && selectedJobRole ? "#2e7d32" : "#999"}>
                  {selectedSector && selectedOccupation && selectedJobRole
                    ? `${selectedSector} › ${selectedOccupation} › ${selectedJobRole}`
                    : <span style={{ fontStyle: "italic" }}>Select all three</span>}
                </Typography>
              </Box>
              <TextField
                select
                size="small"
                label="Level"
                value={createLevelId}
                onChange={(e) => setCreateLevelId(e.target.value)}
                sx={{ mt: 1.5 }}
                fullWidth
              >
                {["L0", "L1", "L2", "L3", "L4"].map((lvl) => (
                  <MenuItem key={lvl} value={lvl}>{lvl}</MenuItem>
                ))}
              </TextField>
              <TextField
                size="small"
                label="Aliases (English, comma-separated)"
                value={createAliasesEn}
                onChange={(e) => setCreateAliasesEn(e.target.value)}
                sx={{ mt: 1 }}
                fullWidth
              />
              <Button
                variant="contained"
                disabled={!selectedSectorId || !selectedOccupationId || !selectedJobRoleId || !candidateMappingSelection.role?._id}
                onClick={handleCreateMapping}
                fullWidth
                sx={{ mt: 1.5 }}
                endIcon={<ArrowForwardIcon />}
              >
                Create Mapping
              </Button>
            </Grid>
          </Grid>

          <Box mt={2} p={2} borderRadius={2} sx={{ bgcolor: "rgba(20,125,112,0.05)", border: "1px solid", borderColor: "divider" }}>
            <Typography fontWeight={700} mb={0.5}>Existing Candidate Role</Typography>
            <Typography variant="caption" color="text.secondary" display="block" mb={1.5}>
              Candidate Families, Groups, Roles, aliases, and allowed levels are managed on the Candidate Role Mappings page.
            </Typography>
            <CandidateRoleSelector value={candidateMappingSelection} onChange={setCandidateMappingSelection} compact />
          </Box>

          <Box mt={2}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle2" fontWeight={600}>Level Labels (Multilingual)</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1.5}>
                  {langCodes.map((code) => (
                    <Grid item xs={12} sm={6} md={3} key={code}>
                      <TextField
                        size="small"
                        label={langLabels[code]}
                        value={createLevelLabels[code]}
                        onChange={(e) => setCreateLevelLabels(prev => ({ ...prev, [code]: e.target.value }))}
                        fullWidth
                      />
                    </Grid>
                  ))}
                </Grid>
                <Box display="flex" justifyContent="flex-end" mt={2}>
                  <Button
                    variant="contained"
                    disabled={!selectedSectorId || !selectedOccupationId || !selectedJobRoleId || !candidateMappingSelection.role?._id}
                    onClick={handleCreateMapping}
                    endIcon={<ArrowForwardIcon />}
                  >
                    Create Mapping
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle2" fontWeight={600}>Aliases (Multilingual, comma-separated)</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1.5}>
                  {langCodes.map((code) => (
                    <Grid item xs={12} sm={6} md={3} key={code}>
                      <TextField
                        size="small"
                        label={langLabels[code]}
                        value={createAliasesLang[code]}
                        onChange={(e) => setCreateAliasesLang(prev => ({ ...prev, [code]: e.target.value }))}
                        fullWidth
                        placeholder="comma-separated"
                      />
                    </Grid>
                  ))}
                </Grid>
                <Box display="flex" justifyContent="flex-end" mt={2}>
                  <Button
                    variant="contained"
                    disabled={!selectedSectorId || !selectedOccupationId || !selectedJobRoleId || !candidateMappingSelection.role?._id}
                    onClick={handleCreateMapping}
                    endIcon={<ArrowForwardIcon />}
                  >
                    Create Mapping
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        </Card>

        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
          <Box display="flex" alignItems="center" gap={2}>
            <Box>
              <Typography variant="subtitle1" fontWeight={600}>Legacy Mapping Records</Typography>
              <Typography variant="caption" color="text.secondary">Read-only compatibility records. Canonical NCO-to-Candidate links above are authoritative.</Typography>
            </Box>
            {!mappingsLoading && <Typography variant="body2" color="text.secondary">{mappingTotal} total</Typography>}
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            {mappingTotalPages > 1 && (
              <Pagination
                count={mappingTotalPages}
                page={mappingPage}
                onChange={(_, value) => setMappingPage(value)}
                color="primary"
                size="small"
                showFirstButton
                showLastButton
              />
            )}
            <TextField
              size="small"
              placeholder="Search mappings..."
              value={mappingSearch}
              onChange={(e) => {
                const val = e.target.value;
                setMappingSearch(val);
                if (searchTimer.current) clearTimeout(searchTimer.current);
                searchTimer.current = setTimeout(() => {
                  setMappingPage(1);
                  loadMappings(1, val);
                }, 300);
              }}
              sx={{ width: 220 }}
              InputProps={{
                startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" color="action" /></InputAdornment>,
              }}
            />
          </Box>
        </Box>

        <CardContent sx={{ maxHeight: "45vh", overflow: "auto", p: 0 }}>
          {mappingsLoading ? (
            <Box display="flex" justifyContent="center" py={6}><CircularProgress /></Box>
          ) : mappings.length === 0 ? (
            <Box textAlign="center" py={6} color="text.secondary">
              <Typography variant="h6" color="text.disabled" mb={1}>No mappings yet</Typography>
              <Typography variant="body2">Legacy compatibility records are retained here. Use the canonical assignment panel above to map the current NCO role.</Typography>
            </Box>
          ) : (
            mappings
              .map((m) => (
                <Paper key={m._id} sx={{ my: 0.8, "&:hover": { bgcolor: "#f8f9ff" } }}>
                  <Box p={2}>
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item xs={12} sm={5}>
                        <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                          <Box component="span" sx={{ fontSize: 18, mr: 0.5 }}>{getIconEmoji(m.family?.family_icon || m.family?.family_name || m.family?.family_id)}</Box>
                          <Chip label="Family" size="small" sx={{ height: 20, fontSize: 10, bgcolor: "#e3f2fd", color: "#1565c0", fontWeight: 600 }} />
                          <Typography variant="body2" fontWeight={600}>{m.family?.family_name || m.family?.family_id}</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                          <Chip label="Group" size="small" sx={{ height: 20, fontSize: 10, bgcolor: "#e8f5e9", color: "#2e7d32", fontWeight: 600 }} />
                          <Typography variant="body2">{m.role_group?.role_group_name || m.role_group?.role_group_id}</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Chip label="Role" size="small" sx={{ height: 20, fontSize: 10, bgcolor: "#fff3e0", color: "#e65100", fontWeight: 600 }} />
                          <Typography variant="body2">{m.role?.role_name || m.role?.role_id}</Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6} sm={3}>
                        <Typography variant="caption" color="text.secondary" display="block">
                          <strong>Level:</strong> {m.level?.level_name || m.level?.level_id || "—"}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" display="block">
                          <strong>Aliases:</strong> {m.role?.aliases?.en?.length ? m.role.aliases.en.slice(0, 2).join(", ") : "—"}
                          {m.role?.aliases?.length > 2 ? ` +${m.role.aliases.length - 2}` : ""}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" display="block">
                          <strong>NCO:</strong> {m.source_mapping?.current_sector || "—"}
                          {m.source_mapping?.current_sector ? ` › ${m.source_mapping?.current_occupation || ""}` : ""}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={2}>
                        <Box display="flex" gap={0.5} flexWrap="wrap">
                          {m.jobsyahan_rules?.is_blue_collar && <Chip label="Blue Collar" size="small" color="info" variant="outlined" sx={{ height: 20, fontSize: 10 }} />}
                          {m.level?.level_id && <Chip label={m.level.level_id} size="small" variant="outlined" sx={{ height: 20, fontSize: 10 }} />}
                        </Box>
                      </Grid>
                      <Grid item xs={3} sm={2}>
                        <Typography variant="caption" color="text.secondary" textAlign="right" display="block">Compatibility record</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              ))
          )}
        </CardContent>

        {mappingTotalPages > 1 && (
          <Box display="flex" justifyContent="center" py={2}>
            <Pagination
              count={mappingTotalPages}
              page={mappingPage}
              onChange={(_, value) => setMappingPage(value)}
              color="primary"
              size="small"
              showFirstButton
              showLastButton
            />
          </Box>
        )}
      </Box> */}

      <ModalComponent
        openModal={editMappingModal.open}
        setOpenModal={() => setEditMappingModal({ open: false, data: null, id: null })}
        modalTitle={`Edit Mapping — ${editMappingModal.data?.role?.role_name || editMappingModal.data?.role?.role_id || ""}`}
        modalWidth="650px"
        handleOnCloseBtnClick={() => setEditMappingModal({ open: false, data: null, id: null })}
      >
        {editMappingModal.data && (
          <Box p={1} component="form" id="edit-mapping-form" onSubmit={(e) => e.preventDefault()}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Family UI Label</Typography>
                <TextField
                  fullWidth size="small"
                  defaultValue={editMappingModal.data.family?.family_ui_label || ""}
                  id="family_ui_label"
                  placeholder="e.g. Sales / Field / Shop"
                />
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Family Sort</Typography>
                <TextField
                  fullWidth size="small" type="number"
                  defaultValue={editMappingModal.data.family?.family_sort_order || 0}
                  id="family_sort_order"
                />
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Family Icon</Typography>
                <TextField select fullWidth size="small" defaultValue={editMappingModal.data.family?.family_icon || ""} id="family_icon">
                  <MenuItem value="">None</MenuItem>
                  {Object.entries(iconOptions).map(([val, label]) => (
                    <MenuItem key={val} value={val}>{getIconEmoji(val)} {label}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Group UI Label</Typography>
                <TextField
                  fullWidth size="small"
                  defaultValue={editMappingModal.data.role_group?.role_group_ui_label || ""}
                  id="role_group_ui_label"
                />
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Group Sort</Typography>
                <TextField
                  fullWidth size="small" type="number"
                  defaultValue={editMappingModal.data.role_group?.role_group_sort_order || 0}
                  id="role_group_sort_order"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Role Description</Typography>
                <TextField
                  fullWidth size="small" multiline minRows={2}
                  defaultValue={editMappingModal.data.role?.role_description || ""}
                  id="role_description"
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Display Title</Typography>
                <TextField
                  fullWidth size="small"
                  defaultValue={editMappingModal.data.display?.display_title || ""}
                  id="display_title"
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Candidate Display Title</Typography>
                <TextField
                  fullWidth size="small"
                  defaultValue={editMappingModal.data.display?.candidate_display_title || ""}
                  id="candidate_display_title"
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Slug</Typography>
                <TextField
                  fullWidth size="small"
                  defaultValue={editMappingModal.data.display?.slug || ""}
                  id="slug"
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Level</Typography>
                <TextField
                  fullWidth size="small"
                  defaultValue={editMappingModal.data.level?.level_id || ""}
                  id="level_id"
                />
              </Grid>
              <Grid item xs={12}>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="caption" fontWeight={600} color="text.secondary">Level Labels (Multilingual)</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={1.5}>
                      {langCodes.map((code) => (
                        <Grid item xs={6} sm={4} md={3} key={code}>
                          <TextField
                            fullWidth size="small"
                            label={langLabels[code]}
                            defaultValue={editMappingModal.data.level?.[`level_label_${code}`] || ""}
                            id={`level_label_${code}`}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ mt: 1, display: "block" }}>Aliases (Multilingual, comma-separated)</Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3}>
                <TextField
                  fullWidth size="small"
                  label="English"
                  defaultValue={(editMappingModal.data.role?.aliases?.en || []).join(", ")}
                  id="aliases_en"
                />
              </Grid>
              {langCodes.map((code) => (
                <Grid item xs={6} sm={4} md={3} key={code}>
                  <TextField
                    fullWidth size="small"
                    label={langLabels[code]}
                    defaultValue={(editMappingModal.data.role?.aliases?.[code] || []).join(", ")}
                    id={`aliases_${code}`}
                  />
                </Grid>
              ))}
              <Grid item xs={4}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Match Strategy</Typography>
                <TextField
                  fullWidth size="small"
                  defaultValue={editMappingModal.data.matching?.match_strategy || ""}
                  id="match_strategy"
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Allow Nearby Roles</Typography>
                <TextField
                  fullWidth size="small"
                  defaultValue={editMappingModal.data.matching?.allow_nearby_roles ? "true" : "false"}
                  id="allow_nearby_roles"
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" fontWeight={600} color="text.secondary">Blue Collar</Typography>
                <TextField
                  fullWidth size="small"
                  defaultValue={editMappingModal.data.jobsyahan_rules?.is_blue_collar ? "true" : "false"}
                  id="is_blue_collar"
                />
              </Grid>
            </Grid>
            <Box display="flex" justifyContent="flex-end" mt={3} gap={1} sx={{ position: "sticky", bottom: 0, bgcolor: "#fff", py: 1, borderTop: "1px solid #e0e0e0", zIndex: 1 }}>
              <Button
                variant="outlined"
                onClick={() => setEditMappingModal({ open: false, data: null, id: null })}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                endIcon={mappingUpdateLoading ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : ""}
                disabled={mappingUpdateLoading}
                onClick={() => {
                  if (mappingUpdateLoading) return;
                  const form = document.getElementById("edit-mapping-form");
                  const inputs = form.querySelectorAll("input, textarea");
                  const payload = {};
                  inputs.forEach((el) => {
                    const val = el.value;
                    if (el.id === "family_ui_label") payload["family.family_ui_label"] = val || null;
                    if (el.id === "family_sort_order") payload["family.family_sort_order"] = parseInt(val) || 0;
                    if (el.id === "family_icon") payload["family.family_icon"] = val || null;
                    if (el.id === "role_group_ui_label") payload["role_group.role_group_ui_label"] = val || null;
                    if (el.id === "role_group_sort_order") payload["role_group.role_group_sort_order"] = parseInt(val) || 0;
                    if (el.id === "role_description") payload["role.role_description"] = val || null;
                    if (el.id === "display_title") payload["display.display_title"] = val || null;
                    if (el.id === "candidate_display_title") payload["display.candidate_display_title"] = val || null;
                    if (el.id === "slug") payload["display.slug"] = val || null;
                    if (el.id === "level_id") payload["level.level_id"] = val || null;
                    if (el.id.startsWith("level_label_")) payload[`level.${el.id}`] = val || null;
                    if (el.id === "match_strategy") payload["matching.match_strategy"] = val || null;
                    if (el.id === "allow_nearby_roles") payload["matching.allow_nearby_roles"] = val === "true";
                    if (el.id === "is_blue_collar") payload["jobsyahan_rules.is_blue_collar"] = val === "true";
                  });
                  const aliasesObj = { en: [] };
                  langCodes.forEach((code) => { aliasesObj[code] = []; });
                  const aliasInputs = form.querySelectorAll("[id^='aliases_']");
                  aliasInputs.forEach((el) => {
                    const lang = el.id.replace("aliases_", "");
                    aliasesObj[lang] = el.value ? el.value.split(",").map(s => s.trim()).filter(Boolean) : [];
                  });
                  payload["role.aliases"] = aliasesObj;
                  handleUpdateMapping(payload);
                }}
              >
                Save
              </Button>
            </Box>
          </Box>
        )}
      </ModalComponent>

      <SureYouWantToDeletModal
        openDeleteModal={deleteMappingModal.open}
        setOpenDeleteModal={() => setDeleteMappingModal({ ...deleteMappingModal, open: false })}
        modalTitle="Delete Mapping"
        dialogBody={`Are you sure you want to delete mapping "${deleteMappingModal.name}"?`}
        onYesClick={handleDeleteMapping}
        endIcon={mappingDeleteLoading ? <CircularProgress sx={{ color: "#fff" }} size={20} /> : ""}
        disabled={mappingDeleteLoading}
      />

      <ModalComponent
        openModal={openSectorModal}
        setOpenModal={setOpenSectorModal}
        modalTitle={
          editJobSectorId ? "Update New Job Sector" : "Create New Job Sector"
        }
        modalWidth={modalWidth}
        handleOnCloseBtnClick={() => {
          handleCloseJobSectorModal();
        }}
      >
        <Formik
          enableReinitialize
          initialValues={initialStateForJobSector}
          validationSchema={CreateSectorValidationSchema}
          onSubmit={(values, { setFieldError }) => {
            if (activeStep < JobSectorStepper.length - 1) {
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              return;
            }
            if (pageName === "seo" &&
              values?.sectorPageContent?.length !== 0 &&
              values?.sectorPageContent?.length < 250
            ) {
              setFieldError(
                "sectorPageContent",
                "Page Content must be atleast 250 characters"
              );
              return;
            }

            setShowLoaderForSector(true);
            handleJobSectorSubmit(values);
          }}
        >
          {({
            errors,
            values,
            setFieldValue,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => {
            return (
              <form onSubmit={handleSubmit} noValidate>
                <Stepper activeStep={activeStep} sx={{ width: "80%", margin: "10px auto" }}>
                  {JobSectorStepper.map((label, index) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>

                {activeStep === 0 && <Grid container paddingX={2} paddingY={2} spacing={1}>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="sectorNameEn"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      English
                    </label>
                    <TextField
                      value={values.sectorNameEn}
                      size="small"
                      // label="Sector Name English"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.sectorNameEn)}
                      helperText={errors.sectorNameEn}
                      id="sectorNameEn"
                      name="sectorNameEn"
                      disabled={pageName === "seo"}
                      placeholder="English"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="sectorNameHn"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Hinglish
                    </label>
                    <TextField
                      value={values.sectorNameHn}
                      size="small"
                      placeholder="Hinglish"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.sectorNameHn)}
                      helperText={errors.sectorNameHn}
                      name="sectorNameHn"
                      disabled={pageName === "seo"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="sectorNameHn"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Hindi
                    </label>
                    <TextField
                      value={values.sectorNameHi}
                      size="small"
                      placeholder="Hindi"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.sectorNameHi)}
                      helperText={errors.sectorNameHi}
                      name="sectorNameHi"
                      disabled={pageName === "seo"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="sectorNameTa"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Tamil
                    </label>
                    <TextField
                      value={values.sectorNameTa}
                      size="small"
                      placeholder="Tamil"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.sectorNameTa)}
                      helperText={errors.sectorNameTa}
                      name="sectorNameTa"
                      disabled={pageName === "seo"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="sectorNameTe"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Telugu
                    </label>
                    <TextField
                      value={values.sectorNameTe}
                      size="small"
                      placeholder="Telugu"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.sectorNameTe)}
                      helperText={errors.sectorNameTe}
                      name="sectorNameTe"
                      disabled={pageName === "seo"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="sectorNameKn"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Kannada
                    </label>
                    <TextField
                      value={values.sectorNameKn}
                      size="small"
                      placeholder="Kannada"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.sectorNameKn)}
                      helperText={errors.sectorNameKn}
                      name="sectorNameKn"
                      disabled={pageName === "seo"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="sectorNameBn"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Bengali
                    </label>
                    <TextField
                      value={values.sectorNameBn}
                      size="small"
                      placeholder="Bengali"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.sectorNameBn)}
                      helperText={errors.sectorNameBn}
                      name="sectorNameBn"
                      disabled={pageName === "seo"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="sectorNameGu"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Gujrati
                    </label>
                    <TextField
                      value={values.sectorNameGu}
                      size="small"
                      placeholder="Gujrati"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.sectorNameGu)}
                      helperText={errors.sectorNameGu}
                      name="sectorNameGu"
                      disabled={pageName === "seo"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="sectorNameMr"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Marathi
                    </label>
                    <TextField
                      value={values.sectorNameMr}
                      size="small"
                      placeholder="Marathi"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.sectorNameMr)}
                      helperText={errors.sectorNameMr}
                      name="sectorNameMr"
                      disabled={pageName === "seo"}
                    />
                  </Grid>

                </Grid>}

                {activeStep === 1 && <Grid justifyContent="center" item xs={12}>
                  <Box
                    display="flex"
                    className="cursor-pointer"
                    justifyContent="center"
                    width="100%"
                    height={200}
                    paddingX={2} paddingY={2}
                  >
                    <DragAndDropComponent
                      dndTitle="Please Drag and Drop your svg , png File"
                      dndwidth={50}
                      dndHeight={100}
                      name="svgPngImg"
                      onChange={(file) => {
                        setFieldValue("svgPngImg", file);
                      }}
                      fileData={fileData}
                      disabled={pageName === "seo"}
                    />
                  </Box>
                  {errors.svgPngImg && (
                    <Typography
                      fontSize="14px"
                      color="#d32f2f"
                      marginTop={2}
                      textAlign="center"
                    >
                      {errors.svgPngImg}
                    </Typography>
                  )}
                </Grid>}

                {pageName === "seo" && activeStep === 2 ? (
                  <Grid container paddingX={2} paddingY={2} spacing={1}>
                    <Typography
                      sx={{
                        textTransform: "capitalize",
                        padding: "0px 10px",
                        fontWeight: "600",
                      }}
                    >
                      SEO Section
                    </Typography>
                    <Grid item xs={12} md={12}>
                      <TextField
                        value={values.sectorSeoTitle}
                        size="small"
                        label="Title"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="sectorSeoTitle"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        value={values.sectorSeoDescription}
                        size="small"
                        label="Description"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        multiline
                        minRows={3}
                        // error={Boolean(errors.sectorSeoDescription)}
                        // helperText={errors.sectorSeoDescription}
                        name="sectorSeoDescription"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        value={values.sectorPageTitle}
                        size="small"
                        label="Page Title"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        // error={Boolean(errors.sectorPageTitle)}
                        // helperText={errors.sectorPageTitle}
                        name="sectorPageTitle"
                      />
                    </Grid>
                    {/* <Grid item xs={12} md={12}>
                      <TextField
                        value={values.sectorPageContent}
                        size="small"
                        label="Page Description"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        multiline
                        minRows={6}
                        error={Boolean(errors.sectorPageContent)}
                        helperText={errors.sectorPageContent}
                        name="sectorPageContent"
                      />
                    </Grid> */}
                    <Grid item xs={12} md={12}>

                      <RichTextEditorWrapper
                        value={values.sectorPageContent}
                        setFieldValue={setFieldValue}
                        fieldName="sectorPageContent"
                        handleBlur={handleBlur}
                      />

                      {errors.sectorPageContent && (
                        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                          {errors.sectorPageContent}
                        </div>
                      )}
                    </Grid>


                  </Grid>
                ) : (
                  ""
                )}
                <Box
                  sx={{ borderTop: "1px solid #bdbdbd" }}
                  paddingY={1}
                  display="flex"
                  justifyContent="flex-end"
                >
                  {activeStep === JobSectorStepper.length - 1 ? (
                    <>
                      <Box marginRight={1}>
                        <Button
                          onClick={() => {
                            handleCloseJobSectorModal();
                          }}
                          disableElevation
                          variant="contained"
                          color="error"
                          disabled={showLoaderForSector}
                        >
                          Cancel
                        </Button>
                      </Box>
                      <Box marginRight={1}>
                        <Button
                          type="submit"
                          disableElevation
                          variant="contained"
                          endIcon={
                            showLoaderForSector ? (
                              <CircularProgress
                                sx={{ color: "#fff" }}
                                size={20}
                              />
                            ) : (
                              ""
                            )
                          }
                          disabled={showLoaderForSector}
                        >
                          {editJobSectorId ? "Update" : "Create"}
                        </Button>
                      </Box>
                    </>
                  ) : (
                    <Box marginRight={1}>
                      <Button
                        type="submit"
                        disableElevation
                        variant="contained"
                        color='success'
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                      >
                        Continue
                      </Button>
                    </Box>
                  )}
                </Box>
              </form>
            );
          }}
        </Formik>
      </ModalComponent>

      <SureYouWantToDeletModal
        openDeleteModal={openDeleteJobSectorModal}
        setOpenDeleteModal={setOpenDeleteJobSectorModal}
        modalTitle="Delete Job Sector"
        dialogBody={`Are you sure you want to delete ${initialStateForJobSector.sectorNameEn}`}
        onYesClick={() => {
          setShowLoaderForSector(true);
          handleDeleteJobSector();
        }}
        endIcon={
          showLoaderForSector ? (
            <CircularProgress sx={{ color: "#fff" }} size={20} />
          ) : (
            ""
          )
        }
        disabled={showLoaderForSector}
      />

      <ModalComponent
        openModal={openDepartmentModal}
        setOpenModal={setOpenDepartmentModal}
        modalTitle={departmentId ? "Update Occupation" : "Create Occupation"}
        modalWidth={modalWidth}
        handleOnCloseBtnClick={() => {
          handleCloseDepartmentModal();
        }}
      >
        <Formik
          enableReinitialize
          initialValues={initialStateForDepartment}
          validationSchema={activeStep === 0 ? CreateOccupationValidationSchema : CreateOccupationValidationSecondSchema}
          onSubmit={(values, { setErrors, setFieldError }) => {
            if (activeStep < JobSectorStepper.length - 1) {
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              return;
            }
            if (
              values?.occupationPageContent?.length > 0 &&
              values?.occupationPageContent?.length < 250
            ) {
              setFieldError(
                "occupationPageContent",
                "Content should be atleast 250 characters long"
              );
              return;
            }
            setShowLoaderForDepartement(true);
            handleDepartmentSubmit(values, setErrors);
          }}
        >
          {({
            errors,
            values,
            handleBlur,
            setFieldValue,
            handleChange,
            handleSubmit,
          }) => {
            return (
              <form onSubmit={handleSubmit} noValidate>
                <Stepper activeStep={activeStep} sx={{ width: "80%", margin: "10px auto" }}>
                  {JobOccupationStepper.map((label, index) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
                {activeStep === 0 && <Grid container paddingX={2} paddingY={2} spacing={1}>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="occupationNameEn"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      English
                    </label>
                    <TextField
                      value={values.occupationNameEn}
                      size="small"
                      placeholder="English"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.occupationNameEn)}
                      helperText={errors.occupationNameEn}
                      name="occupationNameEn"
                      disabled={pageName === "seo"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="occupationNameHn"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Hinglish
                    </label>
                    <TextField
                      value={values.occupationNameHn}
                      size="small"
                      placeholder="Hinglish"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.occupationNameHn)}
                      helperText={errors.occupationNameHn}
                      name="occupationNameHn"
                      disabled={pageName === "seo"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="occupationNameHi"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Hindi
                    </label>
                    <TextField
                      value={values.occupationNameHi}
                      size="small"
                      placeholder="Hindi"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.occupationNameHi)}
                      helperText={errors.occupationNameHi}
                      name="occupationNameHi"
                      disabled={pageName === "seo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="occupationNameTa"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Tamil
                    </label>
                    <TextField
                      value={values.occupationNameTa}
                      size="small"
                      placeholder="Tamil"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.occupationNameTa)}
                      helperText={errors.occupationNameTa}
                      name="occupationNameTa"
                      disabled={pageName === "seo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="occupationNameTe"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Telugu
                    </label>
                    <TextField
                      value={values.occupationNameTe}
                      size="small"
                      placeholder="Telugu"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.occupationNameTe)}
                      helperText={errors.occupationNameTe}
                      name="occupationNameTe"
                      disabled={pageName === "seo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="occupationNameKn"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Kannada
                    </label>
                    <TextField
                      value={values.occupationNameKn}
                      size="small"
                      placeholder="Kannada"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.occupationNameKn)}
                      helperText={errors.occupationNameKn}
                      name="occupationNameKn"
                      disabled={pageName === "seo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="occupationNameBn"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Bengali
                    </label>
                    <TextField
                      value={values.occupationNameBn}
                      size="small"
                      placeholder="Bengali"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.occupationNameBn)}
                      helperText={errors.occupationNameBn}
                      name="occupationNameBn"
                      disabled={pageName === "seo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="occupationNameGu"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Gujrati
                    </label>
                    <TextField
                      value={values.occupationNameGu}
                      size="small"
                      placeholder="Gujrati"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.occupationNameGu)}
                      helperText={errors.occupationNameGu}
                      name="occupationNameGu"
                      disabled={pageName === "seo"}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <label
                      className="form-label"
                      htmlFor="occupationNameMr"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Marathi
                    </label>
                    <TextField
                      value={values.occupationNameMr}
                      size="small"
                      placeholder="Marathi"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.occupationNameMr)}
                      helperText={errors.occupationNameMr}
                      name="occupationNameMr"
                      disabled={pageName === "seo"}
                    />
                  </Grid>

                </Grid>}

                {activeStep === 1 && <Grid container paddingX={2} paddingY={2} spacing={1}>
                  <Grid item xs={12} md={12}>
                    <label
                      className="form-label"
                      htmlFor="ncoId"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      NCO ID
                    </label>
                    <TextField
                      value={values.ncoId}
                      size="small"
                      placeholder="NCO Id"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(errors.ncoId)}
                      helperText={errors.ncoId}
                      name="ncoId"
                      disabled={pageName === "seo"}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <label
                      className="form-label"
                      style={{
                        color: "rgb(38 38 38)",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Sectors
                    </label>
                    <Autocomplete
                      multiple
                      id="checkboxes-tags-demo"
                      options={sector}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.sectorNameEn}
                      renderOption={(props, option, { selected }) => (
                        <li {...props} style={{ textTransform: "capitalize" }}>
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.sectorNameEn}
                        </li>
                      )}
                      // style={{ width: 500 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label=""
                          placeholder="Sectors"
                          error={errors.sectorId}
                          helperText={
                            errors.sectorId && errors.sectorId.toUpperCase()
                          }
                          InputProps={{
                            ...params.InputProps,
                            style: { textTransform: "capitalize" },
                          }}
                        />
                      )}
                      onChange={(event, value) =>
                        handleAutocompleteChange(event, value, setFieldValue)
                      }
                      disabled={pageName === "seo"}
                      value={selectedSectors}
                    // value={initialStateForDepartment.sectorId}
                    />
                  </Grid>
                  <Grid justifyContent="center" item xs={12}>
                    <Box display="flex" className="cursor-pointer" justifyContent="center" width="100%" height={200} >
                      <DragAndDropComponent
                        dndTitle="Please Drag and Drop your svg , png File" dndwidth={50} dndHeight={100}
                        name="svgPngImg"
                        onChange={(file) => {
                          setFieldValue("svgPngImg", file);
                        }}
                        disabled={pageName === "seo"}
                      />
                    </Box>
                    {errors.svgPngImg && <Typography fontSize="14px" color="#d32f2f" marginTop={2} textAlign="center" >{errors.svgPngImg}</Typography>}

                  </Grid>
                </Grid>}

                {(pageName === "seo" && activeStep === JobOccupationStepper.length - 1) ? (
                  <Grid container paddingX={2} paddingY={2} spacing={1}>
                    <Typography
                      sx={{
                        textTransform: "capitalize",
                        padding: "0px 10px",
                        fontWeight: "600",
                      }}
                    >
                      SEO Section
                    </Typography>

                    <Grid item xs={12} md={12}>
                      <TextField
                        value={values.occupationSeoTitle}
                        size="small"
                        label="Title"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="occupationSeoTitle"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        value={values.occupationSeoDescription}
                        size="small"
                        label="Description"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        multiline
                        minRows={3}
                        // error={Boolean(errors.sectorSeoDescription)}
                        // helperText={errors.sectorSeoDescription}
                        name="occupationSeoDescription"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        value={values.occupationPageTitle}
                        size="small"
                        label="Page Title"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        // error={Boolean(errors.sectorPageTitle)}
                        // helperText={errors.sectorPageTitle}
                        name="occupationPageTitle"
                      />
                    </Grid>
                    {/* <Grid item xs={12} md={12}>


                      <TextField
                        value={values.occupationPageContent}
                        size="small"
                        label="Page Description"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        multiline
                        minRows={6}
                        error={Boolean(errors.occupationPageContent)}
                        helperText={errors.occupationPageContent}
                        name="occupationPageContent"
                      />
                    </Grid> */}

                    <Grid item xs={12} md={12}>

                      <RichTextEditorWrapper
                        value={values.occupationPageContent}
                        setFieldValue={setFieldValue}
                        fieldName="occupationPageContent"
                        handleBlur={handleBlur}
                      />

                      {errors.occupationPageContent && (
                        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                          {errors.occupationPageContent}
                        </div>
                      )}
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}

                <Box
                  sx={{ borderTop: "1px solid #bdbdbd" }}
                  paddingY={1}
                  display="flex"
                  justifyContent="flex-end"
                >
                  {activeStep === JobOccupationStepper.length - 1 ? (
                    <>
                      <Box marginRight={1}>
                        <Button
                          onClick={() => {
                            handleCloseDepartmentModal();
                          }}
                          disableElevation
                          variant="contained"
                          color="error"
                          disabled={showLoaderForDepartement}
                        >
                          Cancel
                        </Button>
                      </Box>
                      <Box marginRight={1}>
                        <Button
                          type="submit"
                          disableElevation
                          variant="contained"
                          endIcon={
                            showLoaderForDepartement ? (
                              <CircularProgress sx={{ color: "#fff" }} size={20} />
                            ) : (
                              ""
                            )
                          }
                          disabled={showLoaderForDepartement}
                        >
                          {departmentId ? "Update" : "Create"}
                        </Button>
                      </Box>
                    </>
                  ) : (
                    <Box marginRight={1}>
                      <Button
                        type="submit"
                        disableElevation
                        variant="contained"
                        color='success'
                      >
                        Continue
                      </Button>
                    </Box>
                  )}

                </Box>
              </form>
            );
          }}
        </Formik>
      </ModalComponent>

      <SureYouWantToDeletModal
        openDeleteModal={openDeleteModalOfDepartment}
        setOpenDeleteModal={() => {
          setDepartmentId("");
          setOpenDeleteModalOfDepartment(false);
        }}
        modalTitle="Delete Occupation"
        dialogBody={`Are you sure you want to delete " ${initialStateForDepartment.occupationNameEn} " Occupation`}
        onYesClick={() => {
          setShowLoaderForDepartement(true);
          handleDeleteDepartment();
        }}
        endIcon={
          showLoaderForDepartement ? (
            <CircularProgress sx={{ color: "#fff" }} size={20} />
          ) : (
            ""
          )
        }
        disabled={showLoaderForDepartement}
      />

      <SureYouWantToDeletModal
        openDeleteModal={openDeleteModalOfJobRole}
        setOpenDeleteModal={() => {
          setJobRoleId("");
          setOpenDeleteModalOfJobRole(false);
        }}
        modalTitle="Delete Job Role"
        dialogBody={`Are you sure you want to delete " ${initialStateForJobRole.jobRoleNameEn} " Job Role`}
        onYesClick={() => {
          setShowLoaderForJobRoles(true);
          handleDeleteJobRole();
        }}
        endIcon={
          showLoaderForJobRoles ? (
            <CircularProgress sx={{ color: "#fff" }} size={20} />
          ) : (
            ""
          )
        }
        disabled={showLoaderForJobRoles}
      />

      <ModalComponent
        openModal={ncoPrerequisiteOpen}
        setOpenModal={setNcoPrerequisiteOpen}
        modalTitle="Candidate Role required"
        modalWidth="520px"
        handleOnCloseBtnClick={() => setNcoPrerequisiteOpen(false)}
      >
        <Box p={2}>
          <Typography fontWeight={700} mb={1}>Create or confirm the Candidate Role first.</Typography>
          <Typography color="text.secondary">Every new NCO Role must be mapped to an existing Candidate Role with an English alias. The final step of this form will require that selection.</Typography>
        </Box>
        <Box sx={{ borderTop: "1px solid", borderColor: "divider" }} p={1.5} display="flex" justifyContent="flex-end" gap={1}>
          <Button variant="outlined" onClick={() => navigate("/candidate-role-mappings")}>Create Candidate Role first</Button>
          <Button variant="contained" onClick={() => { setNcoPrerequisiteOpen(false); openJobRoleForm(); }}>I already created it — Continue</Button>
        </Box>
      </ModalComponent>

      <ModalComponent
        openModal={openJobRoleModal}
        setOpenModal={setOpenJobRoleModal}
        modalTitle={jobRoleId ? "Update Job Role" : "Create Job Role"}
        modalWidth={modalWidth}
        handleOnCloseBtnClick={() => {
          handleCloseJobRoleModal();
        }}
      >
        <Formik
          enableReinitialize
          initialValues={initialStateForJobRole}
          validationSchema={activeStep === 0 ? CreateJobRolesValidationSchema : (activeStep === 1 ? CreateJobRolesValidationSecondSchema : CreateJobRolesValidationThirdSchema)}
          onSubmit={(values, { setFieldError }) => {
            if (activeStep < JobRoleStepper.length - 1) {
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              return;
            }
            if (!jobRoleId && !candidateRoleSelection.role?._id) {
              handleSnackBar(true, "Select an existing Candidate Role with an English alias before creating this NCO Role", "warning");
              return;
            }
            if (
              values?.jobRolePageContent?.length > 0 &&
              values?.jobRolePageContent?.length < 250
            ) {
              setFieldError(
                "jobRolePageContent",
                "Content should be atleast 250 characters long"
              );
              return;
            }
            setShowLoaderForJobRoles(true);
            handleJobRoleSubmit(values);
          }}
        >
          {({
            errors,
            values,
            handleBlur,
            setFieldValue,
            handleChange,
            handleSubmit,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <Stepper
                  activeStep={activeStep}
                  sx={{ width: "100%", margin: "10px auto" }}
                >
                  {JobRoleStepper.map((label, index) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>

                {activeStep === 0 && (
                  <Grid container paddingX={2} paddingY={2} spacing={1}>
                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="jobRoleNameEn"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        English
                      </label>
                      <TextField
                        value={values.jobRoleNameEn}
                        size="small"
                        placeholder="English"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.jobRoleNameEn)}
                        helperText={errors.jobRoleNameEn}
                        name="jobRoleNameEn"
                        disabled={pageName === "seo"}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="jobRoleNameHn"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Hinglish
                      </label>
                      <TextField
                        value={values.jobRoleNameHn}
                        size="small"
                        placeholder="Hinglish"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.jobRoleNameHn)}
                        helperText={errors.jobRoleNameHn}
                        name="jobRoleNameHn"
                        disabled={pageName === "seo"}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="jobRoleNameHn"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Hindi
                      </label>
                      <TextField
                        value={values.jobRoleNameHi}
                        size="small"
                        placeholder="Hindi"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.jobRoleNameHi)}
                        helperText={errors.jobRoleNameHi}
                        name="jobRoleNameHi"
                        disabled={pageName === "seo"}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="jobRoleNameTa"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Tamil
                      </label>
                      <TextField
                        value={values.jobRoleNameTa}
                        size="small"
                        placeholder="Tamil"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.jobRoleNameTa)}
                        helperText={errors.jobRoleNameTa}
                        name="jobRoleNameTa"
                        disabled={pageName === "seo"}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="jobRoleNameTe"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Telugu
                      </label>
                      <TextField
                        value={values.jobRoleNameTe}
                        size="small"
                        placeholder="Telugu"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.jobRoleNameTe)}
                        helperText={errors.jobRoleNameTe}
                        name="jobRoleNameTe"
                        disabled={pageName === "seo"}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="jobRoleNameKn"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Kannada
                      </label>
                      <TextField
                        value={values.jobRoleNameKn}
                        size="small"
                        placeholder="Kannada"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.jobRoleNameKn)}
                        helperText={errors.jobRoleNameKn}
                        name="jobRoleNameKn"
                        disabled={pageName === "seo"}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="jobRoleNameBn"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Bengali
                      </label>
                      <TextField
                        value={values.jobRoleNameBn}
                        size="small"
                        placeholder="Bengali"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.jobRoleNameBn)}
                        helperText={errors.jobRoleNameBn}
                        name="jobRoleNameBn"
                        disabled={pageName === "seo"}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="jobRoleNameGu"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Gujrati
                      </label>
                      <TextField
                        value={values.jobRoleNameGu}
                        size="small"
                        placeholder="Gujrati"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.jobRoleNameGu)}
                        helperText={errors.jobRoleNameGu}
                        name="jobRoleNameGu"
                        disabled={pageName === "seo"}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="jobRoleNameMr"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Marathi
                      </label>
                      <TextField
                        value={values.jobRoleNameMr}
                        size="small"
                        placeholder="Marathi"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.jobRoleNameMr)}
                        helperText={errors.jobRoleNameMr}
                        name="jobRoleNameMr"
                        disabled={pageName === "seo"}
                      />
                    </Grid>
                    {/* 
                  <Grid item xs={12} md={6} >
                  <TextField
                    value={values.jobRoleImageUrl}
                    size="small"
                    label="Job Role Image URL"
                    fullWidth
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={Boolean(errors.jobRoleImageUrl)}
                    helperText={errors.jobRoleImageUrl}
                    name="jobRoleImageUrl"
                    disabled={pageName === "seo"}

                  />
                </Grid>
                */}
                  </Grid>
                )}

                {activeStep === 1 && (
                  <Grid container paddingX={2} paddingY={2} spacing={1}>
                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="ncoCode"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        NCO Code
                      </label>
                      <TextField
                        value={values.ncoCode}
                        size="small"
                        placeholder="NCO Code"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.ncoCode)}
                        helperText={errors.ncoCode}
                        name="ncoCode"
                        disabled={pageName === "seo"}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <label
                        className="form-label"
                        htmlFor="nsqfLevel"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        NSQF Level
                      </label>
                      <TextField
                        value={values.nsqfLevel}
                        type="number"
                        size="small"
                        placeholder="NSQF Level"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.nsqfLevel)}
                        helperText={errors.nsqfLevel}
                        name="nsqfLevel"
                        disabled={pageName === "seo"}
                        InputProps={{
                          inputProps: {
                            min: 0,
                            type: "text",
                            style: { textAlign: "left" },
                          },
                        }}
                      />
                    </Grid>

                    <Grid justifyContent="center" item xs={12}>
                      <Box
                        display="flex"
                        className="cursor-pointer"
                        justifyContent="center"
                        width="100%"
                        height={200}
                      >
                        <DragAndDropComponent
                          dndTitle="Please Drag and Drop your svg , png File"
                          dndwidth={50}
                          dndHeight={100}
                          name="svgPngImg"
                          onChange={(file) => {
                            setFieldValue("svgPngImg", file);
                          }}
                          disabled={pageName === "seo"}
                        />
                      </Box>
                      {errors.svgPngImg && (
                        <Typography
                          fontSize="14px"
                          color="#d32f2f"
                          marginTop={2}
                          textAlign="center"
                        >
                          {errors.svgPngImg}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                )}

                {activeStep === 2 && (
                  <Grid container paddingX={2} paddingY={2} spacing={1}>
                    {/* <Grid item xs={12} md={12}>
                      <Box sx={{ fontWeight: 600 }}>
                        Hiring Credits Deductions Details
                      </Box>
                    </Grid> */}

                    <Grid item xs={12} md={12}>
                      <label
                        className="form-label"
                        htmlFor="hiringCreditPerVacancy"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Hiring Credit Per Vacancy
                      </label>
                      <TextField
                        value={values.hiringCreditPerVacancy}
                        type="number"
                        size="small"
                        placeholder="Hiring Credit Per Vacancy"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.hiringCreditPerVacancy)}
                        helperText={errors.hiringCreditPerVacancy}
                        name="hiringCreditPerVacancy"
                        disabled={pageName === "seo"}
                        InputProps={{
                          inputProps: {
                            min: 0,
                            type: "text",
                            style: { textAlign: "left" },
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <label
                        className="form-label"
                        htmlFor="mulHiringCreditAfterVacancy"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Hiring Credit Multiple After First Vacancy
                      </label>
                      <TextField
                        value={values.mulHiringCreditAfterVacancy}
                        type="number"
                        size="small"
                        placeholder="Hiring Credit Multiple After First Vacancy"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.mulHiringCreditAfterVacancy)}
                        helperText={errors.mulHiringCreditAfterVacancy}
                        name="mulHiringCreditAfterVacancy"
                        disabled={pageName === "seo"}
                        InputProps={{
                          inputProps: {
                            min: 0,
                            type: "text",
                            style: { textAlign: "left" },
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <label
                        className="form-label"
                        htmlFor="hiringCreditForContact"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Hiring Credit For Contact
                      </label>
                      <TextField
                        value={values.hiringCreditForContact}
                        type="number"
                        size="small"
                        placeholder="Hiring Credit For Contact"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.hiringCreditForContact)}
                        helperText={errors.hiringCreditForContact}
                        name="hiringCreditForContact"
                        disabled={pageName === "seo"}
                        InputProps={{
                          inputProps: {
                            min: 0,
                            type: "text",
                            style: { textAlign: "left" },
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <label
                        className="form-label"
                        htmlFor="hiringCreditForCVDownload"
                        style={{
                          color: "rgb(38 38 38)",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Hiring Credit For CV Download
                      </label>
                      <TextField
                        value={values.hiringCreditForCVDownload}
                        type="number"
                        size="small"
                        placeholder="Hiring Credit For CV Download"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(errors.hiringCreditForCVDownload)}
                        helperText={errors.hiringCreditForCVDownload}
                        name="hiringCreditForCVDownload"
                        disabled={pageName === "seo"}
                        InputProps={{
                          inputProps: {
                            min: 0,
                            type: "text",
                            style: { textAlign: "left" },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                )}

                {pageName === "seo" &&
                  activeStep === JobRoleStepper.length - 1 ? (
                  <Grid container paddingX={2} paddingY={2} spacing={1}>
                    <Typography
                      sx={{
                        textTransform: "capitalize",
                        padding: "0px 10px",
                        fontWeight: "600",
                      }}
                    >
                      SEO Section
                    </Typography>
                    <Grid item xs={12} md={12}>
                      <TextField
                        value={values.jobRoleSeoTitle}
                        size="small"
                        label="Title"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="jobRoleSeoTitle"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        value={values.jobRoleSeoDescription}
                        size="small"
                        label="Description"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        multiline
                        minRows={3}
                        // error={Boolean(errors.sectorSeoDescription)}
                        // helperText={errors.sectorSeoDescription}
                        name="jobRoleSeoDescription"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        value={values.jobRolePageTitle}
                        size="small"
                        label="Page Title"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        // error={Boolean(errors.sectorPageTitle)}
                        // helperText={errors.sectorPageTitle}
                        name="jobRolePageTitle"
                      />
                    </Grid>
                    {/* <Grid item xs={12} md={12}>
                      <TextField
                        value={values.jobRolePageContent}
                        size="small"
                        label="Page Description"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                        multiline
                        minRows={6}
                        error={Boolean(errors.jobRolePageContent)}
                        helperText={errors.jobRolePageContent}
                        name="jobRolePageContent"
                      />
                    </Grid> */}
                    <Grid item xs={12} md={12}>

                      <RichTextEditorWrapper
                        value={values.jobRolePageContent}
                        setFieldValue={setFieldValue}
                        fieldName="jobRolePageContent"
                        handleBlur={handleBlur}
                      />

                      {errors.jobRolePageContent && (
                        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                          {errors.jobRolePageContent}
                        </div>
                      )}
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}

                {pageName !== "seo" && activeStep === JobRoleStepper.length - 1 && (
                  <Box paddingX={2} paddingY={2}>
                    <Typography fontWeight={700} mb={0.5}>Required Candidate Role Mapping</Typography>
                    <Typography variant="body2" color="text.secondary" mb={2}>
                      Select the already-created Candidate Family, Group, and Role. English aliases and allowed levels are maintained on the Candidate Role.
                    </Typography>
                    <CandidateRoleSelector
                      value={candidateRoleSelection}
                      onChange={setCandidateRoleSelection}
                      required={!jobRoleId}
                    />
                  </Box>
                )}

                {/* <Box paddingX={2} paddingY={2}>
                <Autocomplete
                  className='hello'
                  disablePortal
                  id="combo-box-demo2"
                  options={department}
                  getOptionLabel={(option) => option.occupationNameEn}
                  sx={{ width: 300 }}
                  renderInput={(params) => <TextField className='hello2' {...params} label="Select Occupation" />}
                  onChange={(event, value) => { setSelectedOccupationData(value); }}
                />
              </Box> */}

                <Box
                  sx={{ borderTop: "1px solid #bdbdbd" }}
                  paddingY={1}
                  display="flex"
                  justifyContent="flex-end"
                >
                  {activeStep === JobRoleStepper.length - 1 ? (
                    <>
                      <Box marginRight={1}>
                        <Button
                          onClick={() => {
                            handleCloseJobRoleModal();
                          }}
                          disableElevation
                          variant="contained"
                          color="error"
                          disabled={showLoaderForJobRoles}
                        >
                          Cancel
                        </Button>
                      </Box>
                      <Box marginRight={1}>
                        <Button
                          type="submit"
                          disableElevation
                          variant="contained"
                          endIcon={
                            showLoaderForJobRoles ? (
                              <CircularProgress
                                sx={{ color: "#fff" }}
                                size={20}
                              />
                            ) : (
                              ""
                            )
                          }
                          disabled={showLoaderForJobRoles}
                        >
                          {jobRoleId ? "Update" : "Create"}
                        </Button>
                      </Box>
                    </>
                  ) : (
                    <Box marginRight={1}>
                      <Button
                        type="submit"
                        disableElevation
                        variant="contained"
                        color="success"
                      >
                        Continue
                      </Button>
                    </Box>
                  )}
                </Box>
              </form>
            );
          }}
        </Formik>
      </ModalComponent>

      <ModalComponent
        openModal={openSectorViewModal}
        setOpenModal={setOpenSectorViewModal}
        modalTitle={"Job Sector Details"}
        modalWidth="50%"
        handleOnCloseBtnClick={() => {
          handleCloseJobSectorViewModal();
        }}
      >
        <Box className="p-4" style={{ padding: "20px" }}>
          <Grid container>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Sector Name English</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobSector.sectorNameEn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Sector Name Hinglish</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobSector.sectorNameHn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Sector Name Hindi</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobSector.sectorNameHi}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Sector Name Tamil</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobSector?.sectorNameTa}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Sector Name Telugu</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobSector?.sectorNameTe}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Sector Name Kannada</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobSector?.sectorNameKn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Sector Name Bengali</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobSector?.sectorNameBn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Sector Name Gujrati</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobSector?.sectorNameGu}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Sector Name Marathi</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobSector?.sectorNameMr}
              </Typography>
            </Grid>

            {pageName === "seo" && (
              <>
                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Meta Title</Typography>
                  <Typography
                    style={{ paddingLeft: "10px", textTransform: "capitalize" }}
                  >
                    {initialStateForJobSector.sectorSeoTitle}
                  </Typography>
                </Grid>

                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Meta Description</Typography>
                  <Typography
                    style={{ paddingLeft: "10px", textTransform: "capitalize" }}
                  >
                    {initialStateForJobSector.sectorSeoDescription}
                  </Typography>
                </Grid>

                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Page Title</Typography>
                  <Typography
                    style={{ paddingLeft: "10px", textTransform: "capitalize" }}
                  >
                    {initialStateForJobSector.sectorPageTitle}
                  </Typography>
                </Grid>

                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Page Content</Typography>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: initialStateForJobSector.sectorPageContent,
                    }}
                    style={{ color: "#615F5F" }}
                  />
                </Grid>
              </>
            )}

          </Grid>
        </Box>
      </ModalComponent>

      <ModalComponent
        openModal={openDepartmentViewModal}
        setOpenModal={setOpenDepartmentViewModal}
        modalTitle={"Job Occupation Details"}
        modalWidth="70%"
        handleOnCloseBtnClick={() => {
          handleCloseJobOccupationViewModal();
        }}
      >
        <Box className="p-4" style={{ padding: "20px" }}>
          <Grid container>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Occuaption Name English
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment.occupationNameEn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Occuaption Name Hinglish
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment.occupationNameHn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Occuaption Name Hindi
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment.occupationNameHi}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Occuaption Name Tamil
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment.occupationNameTa}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Occuaption Name Telugu
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment.occupationNameTe}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Occuaption Name Kannada
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment.occupationNameKn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Occuaption Name Bengali
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment.occupationNameBn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Occuaption Name Gujrati
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment.occupationNameGu}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Occuaption Name Marathi
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment.occupationNameMr}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">NCO ID</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment.ncoId}
              </Typography>
            </Grid>

            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Sectors</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForDepartment?.sectorId}
              </Typography>
            </Grid>

            {pageName === "seo" && (
              <>
                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Meta Title</Typography>
                  <Typography
                    style={{ paddingLeft: "10px", textTransform: "capitalize" }}
                  >
                    {initialStateForDepartment.occupationSeoTitle}
                  </Typography>
                </Grid>

                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Meta Description</Typography>
                  <Typography
                    style={{ paddingLeft: "10px", textTransform: "capitalize" }}
                  >
                    {initialStateForDepartment.occupationSeoDescription}
                  </Typography>
                </Grid>

                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Page Title</Typography>
                  <Typography
                    style={{ paddingLeft: "10px", textTransform: "capitalize" }}
                  >
                    {initialStateForDepartment.occupationPageTitle}
                  </Typography>
                </Grid>

                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Page Content</Typography>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: initialStateForDepartment.occupationPageContent,
                    }}
                    style={{ color: "#615F5F" }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </ModalComponent>

      <ModalComponent
        openModal={openJobRoleViewModal}
        setOpenModal={setOpenJobRoleViewModal}
        modalTitle={"Job Role Details"}
        modalWidth="50%"
        handleOnCloseBtnClick={() => {
          handleCloseJobRoleViewModal();
        }}
      >
        <Box className="p-4" style={{ padding: "20px" }}>
          <Grid container>
            {" "}
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Job Role Name English
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.jobRoleNameEn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Job Role Name Hinglish
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.jobRoleNameHn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Job Role Name Hindi</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.jobRoleNameHi}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Job Role Name Tamil</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.jobRoleNameTa}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Job Role Name Telugu</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.jobRoleNameTe}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Job Role Name Kannada</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.jobRoleNameKn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Job Role Name Bengali</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.jobRoleNameBn}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Job Role Name Gujrati</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.jobRoleNameGu}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Job Role Name Marathi</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.jobRoleNameMr}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">NCO Code</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.ncoCode}
              </Typography>
            </Grid>
            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">NSQF Level</Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.nsqfLevel}
              </Typography>
            </Grid>

            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Hiring Credit per vacancy
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.hiringCreditPerVacancy}
              </Typography>
            </Grid>

            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Multiple Hiring Credit After First Vacancy
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.mulHiringCreditAfterVacancy}
              </Typography>
            </Grid>

            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Hiring Credit For Contact
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.hiringCreditForContact}
              </Typography>
            </Grid>

            <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">
                Hiring Credit For CV Downlaod
              </Typography>
              <Typography
                style={{ paddingLeft: "10px", textTransform: "capitalize" }}
              >
                {initialStateForJobRole.hiringCreditForCVDownload}
              </Typography>
            </Grid>


            {/* <Grid item xs={6} className="marginBottom10px">
              <Typography className="fontBold">Job Role Image</Typography>
              <img src={initialStateForJobRole.jobRoleImageUrl} width={50} alt="" />
            </Grid> */}
            {pageName === "seo" && (
              <>
                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Meta Title</Typography>
                  <Typography
                    style={{ paddingLeft: "10px", textTransform: "capitalize" }}
                  >
                    {initialStateForJobRole.jobRoleSeoTitle}
                  </Typography>
                </Grid>

                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Meta Description</Typography>
                  <Typography
                    style={{ paddingLeft: "10px", textTransform: "capitalize" }}
                  >
                    {initialStateForJobRole.jobRoleSeoDescription}
                  </Typography>
                </Grid>

                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Page Title</Typography>
                  <Typography
                    style={{ paddingLeft: "10px", textTransform: "capitalize" }}
                  >
                    {initialStateForJobRole.jobRolePageTitle}
                  </Typography>
                </Grid>

                <Grid item xs={6} className="marginBottom10px">
                  <Typography className="fontBold">Page Content</Typography>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: initialStateForJobRole.jobRolePageContent,
                    }}
                    style={{ color: "#615F5F" }}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} sx={{ mt: 1, pt: 2, borderTop: "1px solid", borderColor: "divider" }}>
              <Typography fontWeight={700} mb={0.5}>Candidate Role Mapping</Typography>
              {jobRoleViewLink.loading ? (
                <Box display="flex" alignItems="center" gap={1} py={1}><CircularProgress size={18} /><Typography variant="body2" color="text.secondary">Loading canonical Candidate Role link…</Typography></Box>
              ) : jobRoleViewLink.error ? (
                <Typography color="error" variant="body2">{jobRoleViewLink.error}</Typography>
              ) : !jobRoleViewLink.data ? (
                <Typography color="text.secondary" variant="body2">No active Candidate Role is linked to this NCO Role.</Typography>
              ) : (
                <Paper variant="outlined" sx={{ p: 1.5, bgcolor: "action.hover" }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={4}><Typography variant="caption" color="text.secondary">Candidate Family</Typography><Typography fontWeight={600}>{jobRoleViewLink.data.candidateRole?.family?.name || "—"}</Typography><ObjectIdBadge objectId={jobRoleViewLink.data.candidateRole?.family?._id} onCopy={handleCopyObjectId} compact label="Family ID" /></Grid>
                    <Grid item xs={12} md={4}><Typography variant="caption" color="text.secondary">Candidate Group</Typography><Typography fontWeight={600}>{jobRoleViewLink.data.candidateRole?.group?.name || "—"}</Typography><ObjectIdBadge objectId={jobRoleViewLink.data.candidateRole?.group?._id} onCopy={handleCopyObjectId} compact label="Group ID" /></Grid>
                    <Grid item xs={12} md={4}><Typography variant="caption" color="text.secondary">Candidate Role</Typography><Typography fontWeight={700}>{jobRoleViewLink.data.candidateRole?.name || "—"}</Typography><Typography variant="caption" display="block">Business ID: {jobRoleViewLink.data.candidateRole?.roleId || "—"}</Typography><ObjectIdBadge objectId={jobRoleViewLink.data.candidateRole?._id} onCopy={handleCopyObjectId} compact label="Candidate Role ID" /></Grid>
                    <Grid item xs={12}><Typography variant="caption" color="text.secondary">Aliases: {(jobRoleViewLink.data.candidateRole?.aliases || []).join(", ") || "—"}</Typography><Typography variant="caption" color="text.secondary" display="block">Allowed levels: {(jobRoleViewLink.data.candidateRole?.allowedLevelIds || []).join(", ") || "—"}</Typography><ObjectIdBadge objectId={jobRoleViewLink.data._id} onCopy={handleCopyObjectId} compact label="Canonical Link ID" /></Grid>
                  </Grid>
                </Paper>
              )}
            </Grid>
          </Grid>
        </Box>
      </ModalComponent>
    </Box>
  ) : (
    <Unauthorized />
  );
};

export default JobSecOccuRole;
